import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { formatDate, Location } from "@angular/common";
import { ApiService } from 'src/app/core/services/api.service';
import { ServiceLocalStorage } from 'src/app/core/services/local-storage.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import { ServiceSharedData } from 'src/app/core/services/shared-data.service';
import { ApiConstants } from 'src/app/core/constants/api-path.constants';
import { ModifyConfirmationComponent } from './modify-confirmation/modify-confirmation.component';
import "leaflet-routing-machine";
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import Swal from 'sweetalert2';
import { Constants } from 'src/app/core/constants/constants';
import { UploadExcelErrorDisplayComponent } from 'src/app/shared/upload-excel-error-display/upload-excel-error-display.component';
import * as XLSX from 'xlsx';
import XlsxPopulate from 'xlsx-populate/browser/xlsx-populate';
import { configureGoogleMapSearchAutocomplete } from 'src/app/core/utils/google-map-latlng-search.util';
declare let google: any;
declare let L;

export class tripModel {
  id: number;
  tripCode: string;
  vehicleType: string;
  vehicleTypeId: number;
  vehicleCap: number;
  escortStatus: boolean;
  tripDetails: any;
  usersList: usersListModel[];
  deviceTripStatus: string;
  tripCodes: string;
}

export class usersListModel {
  userId: number;
  userName: string;
  address: string;
  personalNumber: string;
  bookingid: number;
  routedOrder: number;
  showStatus: string;
  gender: string;
  useraddress: string;
  area: string;
  landMark: string;
  areaPickUpDrop: string;
  landmarkPickUpDrop: string;
  designationName: string;
}

@Component({
  selector: 'app-trip-modify',
  templateUrl: './trip-modify.component.html',
  styleUrls: ['./trip-modify.component.scss']
})
export class TripModifyComponent implements AfterViewInit, OnInit, OnDestroy {

  autoSeqFlag: boolean = false;
  updatePickupTime: boolean = true;
  showUpdatePickupTimeToggle: boolean = false;
  isOsm = false;
  showGoogleMap = false;
  private googleMapInitialized = false;
  private mapLoadAttempts = 0;
  private readonly maxMapLoadAttempts = 30;
  private searchBox: any = null;
  private googleSearchMarker: any = null;
  showGoogleSearch = false;
  private googleSearchControlAttached = false;
  private osmOverlayLayers: any[] = [];
  private osmRouteControls: any[] = [];
  isExceptionDragged: boolean;
  masterFlag: boolean;
  osmTripUsers = [];
  exceptionUsersList: any = [];
  exceptionUsersListDD: any[];
  _tripuserModel: usersListModel = new usersListModel();
  _tripUserModelList: usersListModel[] = [];
  toDropTrip: tripModel = new tripModel();
  _tripModel: tripModel = new tripModel();
  tripsList?: tripModel[] = [];
  tripempmarkers: any = [];
  exceptionEmps: any[] = [];
  vehicleList: any = [];
  tripdetails: any = [];
  tripIds: any = [];
  tripUsersList: any[] = [];
  markers: any = [];
  private routePolylines: any[] = [];
  private directionsRenderers: any[] = [];
  siteid: number;
  shiftid: number;
  date: any;
  lat = 13.0196;
  lng = 77.5968;
  map: any;
  siteData: any;
  sitemarker: any;
  toDropException: any;
  _tripIndex: number;
  _userIndex: number;
  addingNumber = -100;
  isAddTripInProgress = false;
  showAddTripLoading = false;
  private addTripLoadingTimer: ReturnType<typeof setTimeout> | null = null;
  private readonly addTripMinLoadingMs = 400;
  searchUsers: any;
  added: any;
  userSearchkey: any;
  masterRouteName: any;
  colours = [
    "#4B0082",
    "#228B22",
    "#8B0000",
    "#7FFFD4",
    "#000000",
    "#0000FF",
    "#FF8C00",
    "#2F4F4F"
  ];
  activeTabId = 1;
  panelBody = "300px";
  height = "400px";
  private readonly exceptionPanelHeightWithMap = "300px";
  private readonly exceptionPanelHeightWithoutMap = "751px";
  title: any = "Show Map";
  icon: any = "assets/images/red-eye.svg";
  removeUser: any = '';
  selectedUser: any;
  tempData: any = [];
  tempDataSearch: any = [];
  dataFlag: boolean = false;
  routedUserSearchKey: string = '';
  userSelected: any;
  tripDataTemp: any = [];
  dropMsg: boolean = false;
  userFile: string;
  fileUploadChange: any;
  isFileUploaded: any = false;
  uploadedTripData: any[] = [];
  isDesignation = false;
  totalTripUserCount: any = '';
  totalTripCount: any = '';
  uploadModification: boolean = false;
  tripsv3Flag: boolean = false;
  areaLandmark: boolean = true;
  onlyAddress: boolean = false;
  autosaveFlag: boolean = false;
  addTripOnly: boolean = false;
  logType: string = '';
  allowModifyRunningTrip: boolean = false;
  private autoSaveIntervalId: ReturnType<typeof setInterval> | null = null;
  private isDraftSaving = false;
  private dropTimers: ReturnType<typeof setTimeout>[] = [];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private location: Location,
    private readonly apiService: ApiService,
    private serviceSharedData: ServiceSharedData,
    private serviceLocalStorage: ServiceLocalStorage,
    private notifyService: NotificationService,
    private ngxLoader: NgxUiLoaderService,
    private cd: ChangeDetectorRef,
    iconRegistry: MatIconRegistry,
    sanitizer: DomSanitizer,
    private dialog: MatDialog,
  ) {
    iconRegistry.addSvgIcon('stop', sanitizer.bypassSecurityTrustResourceUrl('assets/images/remove-user.svg'));
  }

  ngOnInit() {
    this.tripIds = this.serviceSharedData.getData("trips");
    this.tripUsersList = this.serviceSharedData.getData("tripUsersM");
    this.autosaveFlag = !!this.serviceSharedData.getData("autoSaveModifyTrip");
    this.addTripOnly = !!this.serviceSharedData.getData("addTripOnly");
    this.serviceSharedData.setData("addTripOnly", false);
    if (this.addTripOnly) {
      this.logType = this.serviceSharedData.getData("addTripLogType") || '';
      this.serviceSharedData.setData("addTripLogType", false);
    }
    this.allowModifyRunningTrip = !!this.serviceSharedData.getData("allowModifyRunningTrip");
    this.route.params.subscribe(params => {
      this.shiftid = params["shiftId"];
      this.date = params["date"];
      this.tripsv3Flag = params["tripsv3"] === 'true';
      this.siteid = this.tripsv3Flag
        ? String(params["siteId"]).split(",")[0]
        : params["siteId"];
      this.fetchRestrictPickupTimeUpdateBySiteId(this.siteid);
    });
    this.height = this.addTripOnly ? "0px" : "400px";
    this.panelBody = this.addTripOnly ? this.exceptionPanelHeightWithoutMap : "300px";
    this.title = this.addTripOnly ? "Show Map" : "Hide Map";
    this.icon = this.addTripOnly ? "assets/images/red-eye.svg" : "assets/images/hide.svg";
    this.isDesignationEnabled();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      if (!this.tripIds && !this.addTripOnly) this.onClickBack();
      this.resolveMapTypeAndInit(() => {
        if (this.addTripOnly) {
          this.getSite();
        } else if (this.tripIds != null && this.tripIds.length > 0) {
          this.getSite();
          this.getTripDetails();
        }
      });
    }, 0);
  }

  /** Uses client master-config flag (same as add-edit-user), not company mapType. */
  private resolveMapTypeAndInit(afterInit?: () => void): void {
    const clientCode = localStorage.getItem('clientCode');
    if (!clientCode) {
      this.initMapByClientFlag(afterInit);
      return;
    }
    this.apiService.doGetRequestWithResponse(
      ApiConstants.getMapType + clientCode,
      success => {
        if (success.status === 200) {
          this.serviceLocalStorage.setGoogleMapTypeEnabled(!!success.body?.isGoogleMapEnabled);
        }
        this.initMapByClientFlag(afterInit);
      },
      () => {
        this.initMapByClientFlag(afterInit);
      }
    );
  }

  private initMapByClientFlag(afterInit?: () => void): void {
    this.showGoogleMap = this.serviceLocalStorage.isSetGoogleMapTypeEnabled();
    this.mapLoadAttempts = 0;
    this.googleMapInitialized = false;
    this.searchBox = null;
    this.showGoogleSearch = false;
    if (this.showGoogleMap) {
      this.isOsm = false;
      this.cd.detectChanges();
      this.loadgmap(afterInit);
    } else {
      this.isOsm = true;
      this.cd.detectChanges();
      this.loadOsmap();
      afterInit?.();
    }
  }

  ngOnDestroy(): void {
    this.stopAutoSaveInterval();
    this.clearDropTimers();
  }

  onClickBack() {
    this.stopAutoSaveInterval();
    this.location.back();
    this.exceptionUsersList = [];
  }

  getAllUsers(key: string) {
    const searchKey = key?.trim();
    if (!searchKey || searchKey.length < 3) {
      this.exceptionUsersList = [];
      this.exceptionUsersListDD = [];
      return;
    }
    const site: any = this.siteid;
    const siteId = this.tripsv3Flag ? site.split(',')[0] : this.siteid;
    this.exceptionUsersList = [];
    this.exceptionUsersListDD = [];
    this.apiService.doGetRequestWithResponse(
      ApiConstants.getExceptionAllSubscribedUserBysiteId + searchKey + '&siteId=' + siteId,
      success => {
        this.cd.markForCheck();
        if (success.status === 200) {
          this.exceptionUsersList = success.body;
          this.exceptionUsersListDD = success.body.map(user => ({
            data: user,
            name: user.userInfoDetails.displayName
          }))
        } else {
          this.exceptionUsersList = [];
          this.exceptionUsersListDD = [];
          this.notifyService.showInfo("Exception employee is not present ", null);
        }
      }, error => {
      });
  }

  getTripDetails() {
    const tripsIds = this.tripIds.map(ele => `tripids=${ele}`).join('&');
    const url = this.autosaveFlag ? ApiConstants.getAutoSaveModifyTrips : ApiConstants.gettripsbytripids1;
    this.ngxLoader.start();
    this.apiService.doPostRequestWithResponse(url + tripsIds, '', success => {
      this.ngxLoader.stop();
      if (success.status == 200) {
        this.tripdetails = success.body[0];
        this.totalTripCount = success.body[0].length;
        const allUserIds = success.body[0].flatMap(trip => trip.tripDetails?.tripUsers?.map(u => u.tripUser?.id) || []);
        this.totalTripUserCount = new Set(allUserIds).size;
        success.body[0].forEach((trip, tripIndex) => {
          this._tripModel = new tripModel();
          this._tripModel.id = trip.tripDetails.tripId;
          this._tripModel.tripCode = trip.tripDetails.tripCode == null ? "NA" : this.formatTripCode(trip.tripDetails.tripCode);
          this._tripModel.vehicleTypeId = trip.vehicleType.id;
          this._tripModel.vehicleType = trip.vehicleType.vehicleType;
          this._tripModel.escortStatus = trip.tripDetails.escortStatus;
          this._tripModel.vehicleCap = trip.vehicleType.seatCapacity;
          this._tripModel.tripDetails = trip.tripDetails;
          this._tripModel.deviceTripStatus = trip.DeviceTripStatus;
          this._tripModel.tripCodes = trip.tripDetails.tripCode || 'NA';
          this._tripUserModelList = [];
          let order = 1;
          trip.tripDetails.tripUsers.forEach(user => {
            user.currentStatus = trip.tripDetails.tripId;
            user.tripCode = trip.tripDetails.tripCode == null ? "NA" : this.formatTripCode(trip.tripDetails.tripCode);
            this._tripuserModel = new usersListModel();
            this._tripuserModel.userId = user.tripUser.id;
            this._tripuserModel.userName = user.tripUser.userInfoDetails.displayName;
            this._tripuserModel.routedOrder = order;
            this._tripuserModel.personalNumber = user.tripUser.userInfoDetails.employeeId;
            this._tripuserModel.address = user.landmark.area.area;
            this._tripUserModelList.push(this._tripuserModel);
            this._tripuserModel.showStatus = user.showStatus || 'N/A';
            this._tripuserModel.gender = user.tripUser.userInfoDetails.gender;
            this._tripuserModel.useraddress = user.tripUser.userInfoDetails.address || 'NA';
            this._tripuserModel.landMark = user.userLandmark.landmark || 'NA';
            this._tripuserModel.area = user.userLandmark.area?.area || 'NA';
            this._tripuserModel.areaPickUpDrop = user.tripUser.userInfoDetails.pickUpDrop.area?.area || 'NA';
            this._tripuserModel.landmarkPickUpDrop = user.tripUser.userInfoDetails.pickUpDrop.landmark || 'NA';
            this._tripuserModel.designationName = user.tripUser.userInfoDetails.designationName || 'NA';
            order++;
          });
          this._tripModel.usersList = this._tripUserModelList;
          this.tripsList.push(this._tripModel);
          this.tripDataTemp.push(this._tripModel);
          this.cd.markForCheck();
        });
        if (this.autosaveFlag) {
          const exceptionList = success.body[1]?.exceptionList;
          if (exceptionList && exceptionList.length > 0) {
            this.exceptionEmps = this.mapAutoSaveExceptionEmployees(exceptionList);
          }
          this.syncAddingNumberFromExistingTrips();
          this.startAutoSaveInterval();
        }
        this.rebuildRoutedUserSearchIndex();
        this.showOnMap();
      } else {
        this.notifyService.showInfo("No Trips Found", null);
      }
    }, error => {
      this.ngxLoader.stop();
      this.notifyService.showInfo("No Trips Found", null);
    });
  }

  private formatTripCode(tripCode: string): string {
    if (!tripCode || tripCode === 'NA') {
      return tripCode || 'NA';
    }
    return tripCode.length > 8 ? tripCode.slice(0, 4) + tripCode.slice(-4) : tripCode;
  }

  private mapAutoSaveExceptionEmployees(exceptionList: any[]): any[] {
    return exceptionList.map(item => {
      let tripCode = item.tripCode;
      if (!tripCode && item.tripDetails?.tripCode) {
        tripCode = this.formatTripCode(item.tripDetails.tripCode);
      }
      if (!tripCode && item.currentStatus) {
        tripCode = this.tripsList.find(trip => trip.id === item.currentStatus)?.tripCode;
      }
      if (!tripCode && item.tripUser?.id) {
        for (const trip of this.tripsList) {
          const matchedUser = trip.tripDetails?.tripUsers?.find(
            user => user.tripUser?.id === item.tripUser?.id
          );
          if (matchedUser?.tripCode) {
            tripCode = matchedUser.tripCode;
            break;
          }
        }
      }
      return {
        ...item,
        tripCode: tripCode ? this.formatTripCode(tripCode) : item.tripCode
      };
    });
  }

  removeExceptionUser(i) {
    this.exceptionEmps.splice(i, 1);
  }

  loadOsmap() {
    // this.map = new L.map("map", { fullscreenControl: true, dragging: true }).setView([this.lat, this.lng], 13);
    this.resetTripModifyMapContainer();
    const mapEl = document.getElementById("map");
    if (!mapEl) {
      setTimeout(() => this.loadOsmap(), 100);
      return;
    }
    this.map = new L.map(mapEl, { fullscreenControl: true, dragging: true }).setView([this.lat, this.lng], 13);
    L.tileLayer(Constants.OSM_TILE, { attribution: Constants.OSM_CONTRIBUTORS }).addTo(this.map);
    this.map.addControl(new L.Control.Search(Constants.OSM_NOMINATIM_Obj));
    // const search = GeoSearch.GeoSearchControl({
    //   provider: new GeoSearch.OpenStreetMapProvider(),
    // });
    // this.map.addControl(search);
  }

  loadgmap(afterInit?: () => void) {
    if (!this.showGoogleMap || this.isOsm) {
      return;
    }
    if (this.googleMapInitialized) {
      afterInit?.();
      return;
    }
    const mapEl = document.getElementById('map');
    if (!mapEl) {
      this.scheduleGoogleMapLoadRetry(afterInit);
      return;
    }
    if (typeof google === 'undefined' || (!google.maps?.Map && !google.maps?.importLibrary)) {
      this.scheduleGoogleMapLoadRetry(afterInit);
      return;
    }
    this.initGoogleMapAsync(mapEl, afterInit);
  }

  private scheduleGoogleMapLoadRetry(afterInit?: () => void): void {
    if (++this.mapLoadAttempts >= this.maxMapLoadAttempts) {
      afterInit?.();
      return;
    }
    setTimeout(() => this.loadgmap(afterInit), 100);
  }

  private async initGoogleMapAsync(mapEl: HTMLElement, afterInit?: () => void): Promise<void> {
    if (this.googleMapInitialized) {
      afterInit?.();
      return;
    }
    try {
      const mapCenter = { lat: this.lat, lng: this.lng };
      let MapClass = google.maps?.Map;
      if (google.maps?.importLibrary) {
        const mapsLib = await google.maps.importLibrary('maps') as any;
        MapClass = mapsLib.Map;
      }
      if (!MapClass) {
        this.scheduleGoogleMapLoadRetry(afterInit);
        return;
      }
      this.map = new MapClass(mapEl, {
        center: mapCenter,
        zoom: 12,
        draggable: true,
        zoomControl: true,
        gestureHandling: 'greedy'
      });
      this.googleMapInitialized = true;
      this.googleSearchControlAttached = false;
      google.maps.event.addListenerOnce(this.map, 'idle', () => {
        google.maps.event.trigger(this.map, 'resize');
        // this.map.setCenter(mapCenter);
        this.attachGoogleSearchControl('trip-modify-google-search');
        afterInit?.();
      });
    } catch (error) {
      console.error('Google Map init failed', error);
      this.scheduleGoogleMapLoadRetry(afterInit);
    }
  }

  /** Keeps search UI visible in Google Maps fullscreen (sibling overlays are hidden). */
  private attachGoogleSearchControl(elementId: string): void {
    if (!this.map?.controls || this.googleSearchControlAttached || !this.showGoogleMap) {
      return;
    }
    const searchEl = document.getElementById(elementId);
    if (!searchEl) {
      setTimeout(() => this.attachGoogleSearchControl(elementId), 50);
      return;
    }
    const position = google.maps.ControlPosition?.LEFT_TOP;
    this.map.controls[position].push(searchEl);
    this.googleSearchControlAttached = true;
  }

  openGoogleMapSearch(): void {
    if (!this.showGoogleMap || this.isOsm) {
      return;
    }
    this.showGoogleSearch = true;
    this.searchBox = null;
    setTimeout(() => this.initMapSearchBox(), 0);
  }

  closeGoogleMapSearch(): void {
    this.showGoogleSearch = false;
    this.searchBox = null;
  }

  private initMapSearchBox(): void {
    if (!this.showGoogleMap || this.isOsm || !this.showGoogleSearch || this.searchBox || !this.map) {
      return;
    }
    this.setupMapSearchBox();
  }

  private async setupMapSearchBox(): Promise<void> {
    if (!this.showGoogleMap || this.isOsm || !this.showGoogleSearch || this.searchBox || !this.map) {
      return;
    }

    const container = document.getElementById('autocomplete-container');
    if (!container) {
      if (this.showGoogleSearch) {
        setTimeout(() => this.setupMapSearchBox(), 100);
      }
      return;
    }

    let PlaceAutocompleteElementClass =
      (google.maps as any)?.places?.PlaceAutocompleteElement;
    if (google.maps?.importLibrary) {
      try {
        const placesLib = await google.maps.importLibrary('places') as any;
        PlaceAutocompleteElementClass = placesLib.PlaceAutocompleteElement;
      } catch (error) {
        console.error('Google Places library load failed', error);
      }
    }
    if (!PlaceAutocompleteElementClass) {
      if (this.showGoogleSearch) {
        setTimeout(() => this.setupMapSearchBox(), 100);
      }
      return;
    }

    container.innerHTML = '';
    const autocompleteElement = new PlaceAutocompleteElementClass({
      includedRegionCodes: ['IN'],
      placeholder: 'Search Address'
    });
    container.appendChild(autocompleteElement);
    this.searchBox = configureGoogleMapSearchAutocomplete(autocompleteElement, coords => {
      this.panGoogleMapToPlace(coords, `${coords.lat}, ${coords.lng}`);
      this.closeGoogleMapSearch();
    });
    autocompleteElement.addEventListener('gmp-select', (event: any) => this.onGooglePlaceAutocompleteSelect(event));
    autocompleteElement.addEventListener('gmp-placeselect', (event: any) => this.onGooglePlaceAutocompleteSelect(event));

    // Classic Autocomplete (place_changed) — suggestions can appear without geometry, so the map never moves.
    // if (google.maps?.importLibrary) {
    //   try {
    //     await google.maps.importLibrary('places');
    //   } catch (error) {
    //     console.error('Google Places library load failed', error);
    //   }
    // }
    // const Autocomplete = google.maps?.places?.Autocomplete;
    // if (!Autocomplete) {
    //   setTimeout(() => this.setupMapSearchBox(), 100);
    //   return;
    // }
    // container.innerHTML = '';
    // const input = document.createElement('input');
    // input.type = 'text';
    // input.placeholder = 'Search place';
    // input.className = 'map-search-input form-control';
    // input.setAttribute('autocomplete', 'off');
    // container.appendChild(input);
    // const autocomplete = new Autocomplete(input, {
    //   fields: ['geometry', 'name', 'formatted_address'],
    //   componentRestrictions: { country: 'in' }
    // });
    // if (this.map && typeof autocomplete.bindTo === 'function') {
    //   autocomplete.bindTo('bounds', this.map);
    // }
    // this.searchBox = autocomplete;
    // autocomplete.addListener('place_changed', () => this.onGoogleAutocompletePlaceChanged(autocomplete));
  }

  private async onGooglePlaceAutocompleteSelect(event: any): Promise<void> {
    if (this.isOsm || !this.map) {
      return;
    }
    try {
      const prediction =
        event?.placePrediction ||
        event?.detail?.placePrediction ||
        event?.place ||
        event?.detail?.place;
      if (!prediction) {
        return;
      }
      let place = typeof prediction.toPlace === 'function' ? prediction.toPlace() : prediction;
      if (place && typeof place.then === 'function') {
        place = await place;
      }
      if (place && typeof place.fetchFields === 'function') {
        await place.fetchFields({
          fields: ['displayName', 'formattedAddress', 'location', 'viewport']
        });
      }
      const location = place?.location || place?.geometry?.location;
      const title =
        (typeof place?.displayName === 'string' ? place.displayName : place?.displayName?.text) ||
        place?.formattedAddress ||
        (typeof prediction.text === 'string' ? prediction.text : prediction.text?.text) ||
        prediction.mainText?.text ||
        prediction.description;
      if (location) {
        this.panGoogleMapToPlace(location, title);
        this.closeGoogleMapSearch();
        return;
      }
      if (title) {
        this.geocodeGooglePlaceAndPan(title);
        this.closeGoogleMapSearch();
      }
    } catch (error) {
      console.error('Google place select failed', error);
    }
  }

  private geocodeGooglePlaceAndPan(query: string): void {
    if (!google?.maps?.Geocoder) {
      return;
    }
    const geocoder = new google.maps.Geocoder();
    geocoder.geocode(
      { address: query, componentRestrictions: { country: 'IN' } },
      (results, status) => {
        if (status === 'OK' && results?.[0]?.geometry?.location) {
          this.panGoogleMapToPlace(results[0].geometry.location, query);
        }
      }
    );
  }

  private panGoogleMapToPlace(location: any, title?: string): void {
    if (!this.map || typeof this.map.setCenter !== 'function') {
      return;
    }
    const lat = typeof location.lat === 'function' ? location.lat() : Number(location.lat);
    const lng = typeof location.lng === 'function' ? location.lng() : Number(location.lng);
    if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
      return;
    }
    const latLng = { lat, lng };
    google.maps.event.trigger(this.map, 'resize');
    this.map.setZoom(10);
    this.map.setCenter(latLng);
    if (typeof this.map.panTo === 'function') {
      this.map.panTo(latLng);
    }
    this.setGoogleSearchPin(latLng, title);
  }

  private setGoogleSearchPin(latLng: { lat: number; lng: number }, title?: string): void {
    if (this.googleSearchMarker) {
      this.googleSearchMarker.setMap(null);
      this.googleSearchMarker = null;
    }
    this.googleSearchMarker = new google.maps.Marker({
      position: latLng,
      map: this.map,
      title: title || 'Selected location'
    });
  }

  // private onGoogleAutocompletePlaceChanged(autocomplete: any): void {
  //   if (this.isOsm || !this.map?.setCenter) {
  //     return;
  //   }
  //   const place = autocomplete.getPlace();
  //   const location = place?.geometry?.location;
  //   if (!location) {
  //     return;
  //   }
  //   const lat = typeof location.lat === 'function' ? location.lat() : Number(location.lat);
  //   const lng = typeof location.lng === 'function' ? location.lng() : Number(location.lng);
  //   if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
  //     return;
  //   }
  //   const latLng = { lat, lng };
  //   if (place.geometry.viewport && typeof this.map.fitBounds === 'function') {
  //     this.map.fitBounds(place.geometry.viewport);
  //   } else {
  //     this.map.setCenter(latLng);
  //     this.map.setZoom(16);
  //   }
  //   this.map.panTo?.(latLng);
  // }

  // onItemSelect(e) {
  //   var i = this.exceptionEmps.length;
  //   while (i--) {
  //     if (this.exceptionEmps[i].userAdded === true) {
  //       this.exceptionEmps.splice(i, 1);
  //     }
  //   }
  //   this.xUsers.forEach((emps, i) => {
  //     let exceptionUser: any = {};
  //     exceptionUser.tripUser = emps.data;
  //     exceptionUser.landmark = emps.data.userInfoDetails.pickUpDrop;
  //     exceptionUser.userAdded = true;
  //     this.exceptionEmps.push(exceptionUser);
  //   });
  // }

  // searchUserSubmit(e) {
  //   this.cd.detach();
  //   let triparr = [];
  //   let flag = true;
  //   let tripUser = this.tripUsersList.find(u => u.id == e.id);
  //   // this.tripsList.forEach(trip => {
  //   //   let tripcode = trip.tripCode;
  //   //   trip.usersList.forEach(tuser => {
  //   //     triparr.push({ id: tuser.userId, tripCode: tripcode });
  //   //   });
  //   // });
  //   // triparr.forEach(trip => {
  //   //   if (trip.id == e.id) {
  //   //     flag = false;
  //   //     this.notifyService.showInfo(e.userInfoDetails.displayName + " already added in the " + trip.tripCode, null);
  //   //   }
  //   // });
  //   if (tripUser) {
  //     flag = false;
  //     this.notifyService.showInfo(e.userInfoDetails.displayName + " already added in the " + tripUser.tripCode, null);
  //   }
  //   if (flag) {
  //     if (this.exceptionEmps.length > 0) {
  //       this.exceptionEmps.forEach((emps, i) => {
  //         if ((this.exceptionEmps[i].userAdded === true && emps.tripUser.userInfoDetails.employeeId) == e.userInfoDetails.employeeId) {
  //           this.exceptionEmps.splice(i, 1);
  //           this.notifyService.showInfo(e.userInfoDetails.displayName + " already added in the list!", null);
  //         }
  //       });
  //     }
  //     let exceptionUser: any = {};
  //     exceptionUser.tripUser = e;
  //     exceptionUser.landmark = e.userInfoDetails.pickUpDrop;
  //     exceptionUser.userAdded = true;
  //     this.exceptionEmps.push(exceptionUser);
  //     this.cd.reattach();
  //     this.exceptionUsersList = [];
  //   } else {
  //     this.cd.reattach();
  //     this.exceptionUsersList = [];
  //   }
  // }

  searchUserSubmit(e) {
    this.cd.detach();
    const tripUser = this.tripUsersList.find(u => u.id === e.id);
    if (tripUser) {
      this.notifyService.showInfo(`${e.userInfoDetails.displayName} already added in the ${tripUser.tripCode}`, null);
      this.cd.reattach();
      this.exceptionUsersList = [];
      return;
    }
    const existingIndex = this.exceptionEmps.findIndex(emp =>
      emp.userAdded && emp.tripUser.userInfoDetails.employeeId === e.userInfoDetails.employeeId
    );
    if (existingIndex !== -1) {
      this.exceptionEmps.splice(existingIndex, 1);
      this.notifyService.showInfo(`${e.userInfoDetails.displayName} already added in the list!`, null);
    }
    this.exceptionEmps.push({
      tripUser: e,
      landmark: e.userInfoDetails.pickUpDrop,
      userAdded: true
    });
    this.cd.reattach();
    this.exceptionUsersList = [];
  }

  showOnMap() {
    this.clearGoogleRoutes();
    this.osmTripUsers = [];
    this.tripsList.forEach((element, t) => {
      if (element.tripDetails.tripUsers.length > 0) {
        const waypts = [];
        let startnodelatlng = {
          lat: element.tripDetails.site.landmark.latitude,
          lng: element.tripDetails.site.landmark.longitude
        };
        let endnodelatlng = {
          lat: element.tripDetails.site.landmark.latitude,
          lng: element.tripDetails.site.landmark.longitude
        };
        if (element.tripDetails.shift) {
          if (element.tripDetails.shift.logType == "IN") {
            startnodelatlng = {
              lat: element.tripDetails.tripUsers[0] ? element.tripDetails.tripUsers[0].landmark.latitude : element.tripDetails.site.landmark.latitude,
              lng: element.tripDetails.tripUsers[0] ? element.tripDetails.tripUsers[0].landmark.longitude : element.tripDetails.site.landmark.longitude
            };
          } else {
            endnodelatlng = {
              lat: element.tripDetails.tripUsers[element.tripDetails.tripUsers.length - 1].landmark.latitude,
              lng: element.tripDetails.tripUsers[element.tripDetails.tripUsers.length - 1].landmark.longitude
            };
          }
        }
        let markerlist = [];
        element.tripDetails.tripUsers.forEach((tripuser, tIndex) => {
          waypts.push({
            location: {
              lat: tripuser.landmark.latitude,
              lng: tripuser.landmark.longitude
            },
            stopover: true
          });
          let icon = "./assets/images/livetracking/maleloc.svg";
          if (tripuser.tripUser.userInfoDetails.gender == "Female") {
            icon = "./assets/images/livetracking/femaleloc.svg";
          }
          if (!this.isOsm) {
            var marker = new google.maps.Marker({
              position: {
                lat: tripuser.landmark.latitude,
                lng: tripuser.landmark.longitude
              },
              icon: this.getGoogleEmployeeIcon(icon),
              draggable: false,
              map: this.map,
              title: tripuser.tripUser.userInfoDetails.displayName + " - " + tripuser.routedOrder,
              label: {
                text: "P" + (tIndex + 1),
                color: "black",
                fontWeight: "bold",
                fontSize: "12px"
              }
            });
            markerlist.push(marker);
            this.markers.push(marker);
          }
        });
        this.osmTripUsers.push(element.tripDetails);
        this.tripempmarkers.push({
          tripid: element.tripDetails.tripId,
          markers: markerlist
        });
        if (this.sitemarker == undefined && !this.isOsm) {
          this.markSite(element.tripDetails.site);
        }
        if (!this.isOsm) {
          const isInTrip = element.tripDetails.shift?.logType == "IN";
          // Exclude origin/destination from waypoints — duplicating them skews Google Directions.
          const middleWaypts = isInTrip ? waypts.slice(1) : waypts.slice(0, -1);
          this.drawGoogleTripRoute({
            origin: startnodelatlng,
            destination: endnodelatlng,
            waypoints: middleWaypts,
            optimizeWaypoints: false,
            avoidHighways: false,
            avoidTolls: false,
            travelMode: google.maps.DirectionsTravelMode.DRIVING
          }, this.colours[t % this.colours.length], t === 0);
        }
      }
    });
    if (this.isOsm) {
      this.drawOsmTripPins();
      this.getOsmUsersRoute();
    } else {
      this.ngxLoader.stop();
    }
  }

  /**
   * Draw Google route with explicit Polyline so multi-trip colours match OSM.
   * Uses shortest driving path (same strategy as BE Routes API computeRoutes).
   */
  private async drawGoogleTripRoute(request: any, routeColor: string, fitBounds = false): Promise<void> {
    const toLatLng = (point: any) => {
      if (!point) {
        return null;
      }
      if (typeof point.lat === 'function') {
        return { lat: point.lat(), lng: point.lng() };
      }
      const loc = point.location || point;
      if (typeof loc.lat === 'function') {
        return { lat: loc.lat(), lng: loc.lng() };
      }
      return { lat: loc.lat, lng: loc.lng };
    };
    const origin = toLatLng(request.origin);
    const destination = toLatLng(request.destination);
    const middlePoints = (request.waypoints || []).map(wp => toLatLng(wp)).filter(Boolean);
    if (!origin || !destination) {
      return;
    }
    try {
      const drawn = await this.drawShortestRouteViaMapsJs(origin, destination, middlePoints, routeColor, fitBounds)
        || await this.drawShortestRouteViaRestApi(origin, destination, middlePoints, routeColor, fitBounds);
      if (drawn) {
        return;
      }
    } catch (error) {
      console.warn('Shortest Routes API path failed; falling back to Directions alternatives', error);
    }
    this.drawShortestRouteViaDirectionsService(origin, destination, middlePoints, routeColor, fitBounds);
  }

  private async drawShortestRouteViaMapsJs(
    origin: { lat: number; lng: number },
    destination: { lat: number; lng: number },
    middlePoints: { lat: number; lng: number }[],
    routeColor: string,
    fitBounds: boolean
  ): Promise<boolean> {
    if (!google.maps?.importLibrary) {
      return false;
    }
    const routesLib = await google.maps.importLibrary('routes') as any;
    const RouteClass = routesLib?.Route;
    if (!RouteClass?.computeRoutes) {
      return false;
    }
    const routeRequest: any = {
      origin,
      destination,
      travelMode: 'DRIVE',
      routingPreference: 'TRAFFIC_UNAWARE',
      computeAlternativeRoutes: middlePoints.length === 0,
      fields: ['path', 'distanceMeters', 'polyline']
    };
    if (middlePoints.length) {
      routeRequest.intermediates = middlePoints.map(point => ({ location: point }));
    }
    const { routes } = await RouteClass.computeRoutes(routeRequest);
    const shortest = this.pickShortestRouteByDistanceMeters(routes);
    if (!shortest) {
      return false;
    }
    let path = shortest.path;
    if (!path?.length && shortest.polyline?.encodedPolyline) {
      path = this.decodeGoogleEncodedPolyline(shortest.polyline.encodedPolyline);
    }
    if (!path?.length) {
      return false;
    }
    this.renderGoogleRoutePath(path, routeColor, fitBounds);
    return true;
  }

  private async drawShortestRouteViaRestApi(
    origin: { lat: number; lng: number },
    destination: { lat: number; lng: number },
    middlePoints: { lat: number; lng: number }[],
    routeColor: string,
    fitBounds: boolean
  ): Promise<boolean> {
    const apiKey = this.getGoogleMapsApiKey();
    if (!apiKey) {
      return false;
    }
    const body: any = {
      origin: { location: { latLng: { latitude: origin.lat, longitude: origin.lng } } },
      destination: { location: { latLng: { latitude: destination.lat, longitude: destination.lng } } },
      travelMode: 'DRIVE',
      routingPreference: 'TRAFFIC_UNAWARE',
      computeAlternativeRoutes: middlePoints.length === 0,
      languageCode: 'en-US',
      units: 'METRIC'
    };
    if (middlePoints.length) {
      body.intermediates = middlePoints.map(point => ({
        location: { latLng: { latitude: point.lat, longitude: point.lng } }
      }));
    }
    const response = await fetch('https://routes.googleapis.com/directions/v2:computeRoutes', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Goog-Api-Key': apiKey,
        'X-Goog-FieldMask': 'routes.distanceMeters,routes.polyline.encodedPolyline'
      },
      body: JSON.stringify(body)
    });
    if (!response.ok) {
      console.warn('Routes REST API failed', response.status, await response.text());
      return false;
    }
    const payload = await response.json();
    const shortest = this.pickShortestRouteByDistanceMeters(payload?.routes);
    const encoded = shortest?.polyline?.encodedPolyline;
    if (!encoded) {
      return false;
    }
    this.renderGoogleRoutePath(this.decodeGoogleEncodedPolyline(encoded), routeColor, fitBounds);
    return true;
  }

  private drawShortestRouteViaDirectionsService(
    origin: { lat: number; lng: number },
    destination: { lat: number; lng: number },
    middlePoints: { lat: number; lng: number }[],
    routeColor: string,
    fitBounds: boolean
  ): void {
    const directionsService = new google.maps.DirectionsService();
    const directionsDisplay = new google.maps.DirectionsRenderer({
      suppressMarkers: true,
      suppressPolylines: true,
      preserveViewport: !fitBounds
    });
    directionsDisplay.setMap(this.map);
    this.directionsRenderers.push(directionsDisplay);
    directionsService.route({
      origin,
      destination,
      waypoints: middlePoints.map(point => ({ location: point, stopover: true })),
      optimizeWaypoints: false,
      avoidHighways: false,
      avoidTolls: false,
      provideRouteAlternatives: middlePoints.length === 0,
      travelMode: google.maps.DirectionsTravelMode.DRIVING
    }, (response, status) => {
      if (status !== google.maps.DirectionsStatus.OK || !response?.routes?.length) {
        return;
      }
      const shortestRoute = response.routes.reduce((shortest, route) => {
        const shortestDist = this.getDirectionsRouteDistanceMeters(shortest);
        const routeDist = this.getDirectionsRouteDistanceMeters(route);
        return routeDist < shortestDist ? route : shortest;
      }, response.routes[0]);
      response.routes = [shortestRoute];
      directionsDisplay.setDirections(response);
      this.renderGoogleRoutePath(shortestRoute.overview_path, routeColor, fitBounds);
    });
  }

  private pickShortestRouteByDistanceMeters(routes: any[] | undefined): any | null {
    if (!routes?.length) {
      return null;
    }
    return routes.reduce((shortest, route) => {
      const shortestDist = shortest?.distanceMeters ?? Number.MAX_SAFE_INTEGER;
      const routeDist = route?.distanceMeters ?? Number.MAX_SAFE_INTEGER;
      return routeDist < shortestDist ? route : shortest;
    }, routes[0]);
  }

  private getDirectionsRouteDistanceMeters(route: any): number {
    return (route?.legs || []).reduce((sum, leg) => sum + (leg?.distance?.value || 0), 0);
  }

  private renderGoogleRoutePath(path: any[], routeColor: string, fitBounds = false): void {
    if (!path?.length || !this.map) {
      return;
    }
    const polyline = new google.maps.Polyline({
      path,
      strokeColor: routeColor,
      strokeWeight: 3,
      strokeOpacity: 0.8,
      map: this.map
    });
    this.routePolylines.push(polyline);
    if (fitBounds) {
      const bounds = new google.maps.LatLngBounds();
      path.forEach(point => bounds.extend(point));
      this.map.fitBounds(bounds);
    }
  }

  private getGoogleMapsApiKey(): string | null {
    const scripts = Array.from(document.getElementsByTagName('script'));
    const mapsScript = scripts.find(script => script.src?.includes('maps.googleapis.com/maps/api/js'));
    if (!mapsScript?.src) {
      return null;
    }
    try {
      return new URL(mapsScript.src).searchParams.get('key');
    } catch {
      return null;
    }
  }

  private decodeGoogleEncodedPolyline(encoded: string): { lat: number; lng: number }[] {
    let index = 0;
    let lat = 0;
    let lng = 0;
    const coordinates: { lat: number; lng: number }[] = [];
    while (index < encoded.length) {
      let shift = 0;
      let result = 0;
      let byte: number;
      do {
        byte = encoded.charCodeAt(index++) - 63;
        result |= (byte & 0x1f) << shift;
        shift += 5;
      } while (byte >= 0x20);
      lat += (result & 1) ? ~(result >> 1) : (result >> 1);

      shift = 0;
      result = 0;
      do {
        byte = encoded.charCodeAt(index++) - 63;
        result |= (byte & 0x1f) << shift;
        shift += 5;
      } while (byte >= 0x20);
      lng += (result & 1) ? ~(result >> 1) : (result >> 1);

      coordinates.push({ lat: lat / 1e5, lng: lng / 1e5 });
    }
    return coordinates;
  }

  private clearGoogleRoutes(): void {
    this.routePolylines.forEach(line => line.setMap(null));
    this.routePolylines = [];
    this.directionsRenderers.forEach(renderer => renderer.setMap(null));
    this.directionsRenderers = [];
  }

  /** Keep Google employee pins at a fixed map size (SVGs otherwise render huge). */
  private getGoogleEmployeeIcon(iconUrl: string): any {
    return {
      url: iconUrl,
      scaledSize: new google.maps.Size(50, 50),
      anchor: new google.maps.Point(18, 42),
      labelOrigin: new google.maps.Point(18, -6)
    };
  }

  markSite(site) {
    // let path = "./assets/images/company.png";
    // if (!this.isOsm) {
    //   let sitecordinates = new google.maps.LatLng(
    //     site.landmark.latitude,
    //     site.landmark.longitude
    //   );
    //   this.sitemarker = new google.maps.Marker({
    //     position: sitecordinates,
    //     icon: {
    //       url: path,
    //       scaledSize: new google.maps.Size(40, 40)
    //     },
    //     map: this.map,
    //     title: site.siteName
    //   });
    // } else {
    //   this.sitemarker = new L.marker(
    //     [site.landmark.latitude, site.landmark.longitude],
    //     {
    //       icon: L.icon({
    //         iconUrl: path,
    //         iconSize: [40, 40],
    //         iconAnchor: [20, 40]
    //       }),
    //       title: site.siteName
    //     }
    //   );
    // }

    const iconUrl = "./assets/images/company.png";
    const coords = [site.landmark.latitude, site.landmark.longitude];
    this.sitemarker = this.isOsm
      ? new L.marker(coords, {
        icon: L.icon({
          iconUrl,
          iconSize: [40, 40],
          iconAnchor: [20, 40]
        }),
        title: site.siteName
      }).addTo(this.map)
      : new google.maps.Marker({
        position: new google.maps.LatLng(...coords),
        icon: { url: iconUrl, scaledSize: new google.maps.Size(40, 40) },
        map: this.map,
        title: site.siteName
      });
  }

  private resetTripModifyMapContainer(): void {
    this.clearOsmOverlay();
    if (this.map && typeof this.map.remove === 'function') {
      try {
        this.map.off();
        this.map.remove();
      } catch (error) { }
    }
    this.map = null;
    const el = document.getElementById('map') as any;
    if (el) {
      el._leaflet_id = null;
      el.innerHTML = '';
    }
  }

  private clearOsmOverlay(): void {
    this.osmOverlayLayers.forEach(layer => {
      try {
        this.map?.removeLayer?.(layer);
      } catch (error) { }
    });
    this.osmOverlayLayers = [];
    this.osmRouteControls.forEach(control => {
      try {
        this.map?.removeControl?.(control);
      } catch (error) { }
    });
    this.osmRouteControls = [];
  }

  private drawOsmTripPins(): void {
    if (!this.isOsm || typeof this.map?.addLayer !== 'function') {
      return;
    }
    this.clearOsmOverlay();
    const bounds = [];
    this.tripsList.forEach(trip => {
      const users = trip.tripDetails?.tripUsers || [];
      users.forEach((tripuser, tIndex) => {
        const lat = Number(tripuser.landmark?.latitude);
        const lng = Number(tripuser.landmark?.longitude);
        if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
          return;
        }
        const iconUrl = tripuser.tripUser?.userInfoDetails?.gender === 'Female'
          ? './assets/images/livetracking/femaleloc.svg'
          : './assets/images/livetracking/maleloc.svg';
        const marker = L.marker([lat, lng], {
          icon: L.icon({
            iconUrl,
            iconSize: [65, 70],
            iconAnchor: [32, 70]
          })
        }).bindTooltip(String(tIndex + 1), {
          permanent: true,
          direction: 'left',
          offset: L.point(-10, 0)
        }).addTo(this.map);
        this.osmOverlayLayers.push(marker);
        bounds.push([lat, lng]);
      });
      const site = trip.tripDetails?.site;
      const siteLat = Number(site?.landmark?.latitude);
      const siteLng = Number(site?.landmark?.longitude);
      if (Number.isFinite(siteLat) && Number.isFinite(siteLng)) {
        const siteMarker = L.marker([siteLat, siteLng], {
          icon: L.icon({
            iconUrl: './assets/images/company.png',
            iconSize: [40, 40],
            iconAnchor: [20, 40]
          }),
          title: site.siteName
        }).addTo(this.map);
        this.osmOverlayLayers.push(siteMarker);
        this.sitemarker = siteMarker;
        bounds.push([siteLat, siteLng]);
      }
    });
    if (bounds.length && typeof this.map.fitBounds === 'function') {
      this.map.fitBounds(bounds, { padding: [40, 40], maxZoom: 15 });
    }
  }

  private drawOsmLocalRoutes(): void {
    if (!this.isOsm || typeof this.map?.addLayer !== 'function') {
      return;
    }
    this.tripsList.forEach((trip, t) => {
      const users = trip.tripDetails?.tripUsers || [];
      const site = trip.tripDetails?.site?.landmark;
      if (!users.length || !site) {
        return;
      }
      const wps = [];
      if (trip.tripDetails.shift?.logType === 'OUT') {
        wps.push(L.latLng(site.latitude, site.longitude));
        users.forEach(user => wps.push(L.latLng(user.landmark.latitude, user.landmark.longitude)));
      } else {
        users.forEach(user => wps.push(L.latLng(user.landmark.latitude, user.landmark.longitude)));
        wps.push(L.latLng(site.latitude, site.longitude));
      }
      const routing = L.Routing.control({
        serviceUrl: Constants.OSM_ROUTING_URL,
        showAlternatives: false,
        lineOptions: {
          styles: [{
            color: this.colours[t % this.colours.length],
            weight: 3,
            opacity: 0.8
          }]
        },
        fitSelectedRoutes: false,
        waypointMode: 'connect',
        addWaypoints: false,
        draggableWaypoints: false,
        autoRoute: true,
        reverseWaypoints: false,
        show: false,
        routeWhileDragging: false,
        createMarker: () => null
      }).addTo(this.map);
      routing.setWaypoints(wps);
      routing.hide();
      this.osmRouteControls.push(routing);
    });
  }

  getOsmUsersRoute() {
    const trips = [];
    let op = 0.15;
    // this.tripsList.forEach(trip => {
    //   if (this.removeUser !== trip.id) {
    //     if (trip.tripDetails != null && trip.tripDetails.tripUsers != null && trip.tripDetails.tripUsers.length > 0) {
    //       trips.push(trip.tripDetails);
    //     }
    //   }
    // });
    this.tripsList.forEach(trip => {
      if (trip.tripDetails.tripUsers.length > 0) {
        trips.push(trip.tripDetails);
      }
    });
    let tripDetailList = this.tripsList.filter(trip => trip.tripDetails != null && trip.tripDetails.tripUsers != null && trip.tripDetails.tripUsers.length > 0);
    let k = true;
    const site: any = this.siteid;
    const siteId = this.tripsv3Flag ? site.split(",")[0] : this.siteid;
    const logType = this._tripModel.tripDetails?.shift?.logType || this.logType;
    if (!logType || !trips.length || typeof this.map?.addLayer !== 'function') {
      this.drawOsmLocalRoutes();
      return;
    }
    this.apiService.doPostRequestWithResponse(ApiConstants.gettripmodifypreview + logType + '&siteid=' + siteId, trips, success => {
      if (!success.body?.trips?.some(trip => trip?.OSRM?.waypoints?.length)) {
        this.drawOsmLocalRoutes();
        return;
      }
      this.clearOsmOverlay();
      success.body.trips.forEach((trips, t) => {
        if (!trips?.OSRM?.waypoints) {
          return;
        }
        let wps = [];
        trips.OSRM.waypoints.forEach(wp => {
          wps.push(L.latLng(wp.location[1], wp.location[0]));
        });
        // let t = this.removeUser ? tripDetailList.findIndex(ele => ele.id !== this.removeUser) : index;
        // tripDetailList.forEach(trip => {
        // if (this.removeUser !== trip.id) {
        if (this.removeUser) {
          let objIndex = this.tripsList.findIndex(ele => ele.id == this.removeUser);
          if (this.tripsList[objIndex].tripDetails.tripUsers.length > 0) {
            if (this.tripsList[t].tripDetails.tripUsers.length != 0 && k) {
              let r = L.Routing.control({
                serviceUrl: Constants.OSM_ROUTING_URL,
                showAlternatives: false,
                lineOptions: {
                  styles: [{
                    color: this.colours[t],
                    weight: 3,
                    opacity: 0.8
                  }]
                },
                fitSelectedRoutes: true,
                waypointMode: "connect",
                addWaypoints: false,
                draggableWaypoints: false,
                autoRoute: true,
                reverseWaypoints: false,
                show: true,
                routeWhileDragging: false,
                createMarker: (i, wp, nWps) => {
                  if (success.body.trips[t].LOGTYPE === "IN") {
                    if (i === this.tripsList[t].tripDetails.tripUsers.length) {
                      let m = L.marker(wp.latLng, {
                        icon: L.icon({
                          iconUrl: "./assets/images/company.png",
                          iconSize: [40, 40]
                        })
                      }).bindPopup(
                        this.tripsList[t].tripDetails.tripUsers[
                          this.tripsList[t].tripDetails.tripUsers.length - 1
                        ].landmark.landmark
                      );
                      return m;
                    }
                    if (i < this.tripsList[t].tripDetails.tripUsers.length) {
                      let m = L.marker(wp.latLng, {
                        icon: L.icon({
                          iconUrl: this.tripsList[t].tripDetails.tripUsers[i].tripUser.userInfoDetails.gender === "Female"
                            ? "./assets/images/livetracking/femaleloc.svg" : "./assets/images/livetracking/maleloc.svg",
                          iconSize: [65, 70]
                        })
                      }).bindPopup('<tr><td>UserName : </td<td>' + this.tripsList[t].tripDetails.tripUsers[i].tripUser
                        .userInfoDetails.displayName + '</td><br> <td>AL : </td><td>' +
                        this.tripsList[t].tripDetails.tripUsers[i].landmark.area.area + ', ' +
                        this.tripsList[t].tripDetails.tripUsers[i].landmark.landmark + '</td></tr>').bindTooltip(i + 1 + "", {
                          permanent: true,
                          direction: "left",
                          offset: L.point(-10, 0)
                        })
                        .openTooltip();
                      return m;
                    }
                  } else {
                    if (i === 0) {
                      let m = L.marker(wp.latLng, {
                        icon: L.icon({
                          iconUrl: "./assets/images/company.png",
                          iconSize: [40, 40]
                        })
                      }).bindPopup(
                        this.tripsList[t].tripDetails.tripUsers[0].landmark.landmark
                      );
                      return m;
                    }
                    if (i - 1 <= this.tripsList[t].tripDetails.tripUsers.length) {
                      let m = L.marker(wp.latLng, {
                        icon: L.icon({
                          iconUrl: this.tripsList[t].tripDetails.tripUsers[i - 1].tripUser.userInfoDetails.gender === "Female"
                            ? "./assets/images/livetracking/femaleloc.svg" : "./assets/images/livetracking/maleloc.svg",
                          iconSize: [65, 70]
                        })
                      }).bindPopup('<tr><td>UserName : </td<td>' + this.tripsList[t].tripDetails.tripUsers[i - 1].tripUser
                        .userInfoDetails.displayName + '</td><br> <td>AL : </td><td>' +
                        this.tripsList[t].tripDetails.tripUsers[i - 1].landmark.area.area + ', ' +
                        this.tripsList[t].tripDetails.tripUsers[i - 1].landmark.landmark + '</td></tr>').bindTooltip(i + "", {
                          permanent: true,
                          direction: "left",
                          offset: L.point(-10, 0)
                        }).openTooltip();
                      return m;
                    }
                  }
                  op = op + 0.15;
                }
              }).addTo(this.map);
              r.setWaypoints(wps);
              r.hide();
            } else {
              this.showOnPrevMap(tripDetailList);
            }
          } else {
            if (tripDetailList[t].tripDetails.tripUsers.length != 0 && k) {
              let r = L.Routing.control({
                serviceUrl: Constants.OSM_ROUTING_URL,
                showAlternatives: false,
                lineOptions: {
                  styles: [{
                    color: this.colours[t],
                    weight: 3,
                    opacity: 0.8
                  }]
                },
                fitSelectedRoutes: true,
                waypointMode: "connect",
                addWaypoints: false,
                draggableWaypoints: false,
                autoRoute: true,
                reverseWaypoints: false,
                show: true,
                routeWhileDragging: false,
                createMarker: (i, wp, nWps) => {
                  if (success.body.trips[t].LOGTYPE === "IN") {
                    if (i === tripDetailList[t].tripDetails.tripUsers.length) {
                      let m = L.marker(wp.latLng, {
                        icon: L.icon({
                          iconUrl: "./assets/images/company.png",
                          iconSize: [40, 40]
                        })
                      }).bindPopup(
                        tripDetailList[t].tripDetails.tripUsers[
                          tripDetailList[t].tripDetails.tripUsers.length - 1
                        ].landmark.landmark
                      );
                      return m;
                    }
                    if (i < tripDetailList[t].tripDetails.tripUsers.length) {
                      let m = L.marker(wp.latLng, {
                        icon: L.icon({
                          iconUrl: tripDetailList[t].tripDetails.tripUsers[i].tripUser.userInfoDetails.gender === "Female"
                            ? "./assets/images/livetracking/femaleloc.svg" : "./assets/images/livetracking/maleloc.svg",
                          iconSize: [65, 70]
                        })
                      }).bindPopup('<tr><td>UserName : </td<td>' + tripDetailList[t].tripDetails.tripUsers[i].tripUser
                        .userInfoDetails.displayName + '</td><br> <td>AL : </td><td>' +
                        tripDetailList[t].tripDetails.tripUsers[i].landmark.area.area + ', ' +
                        tripDetailList[t].tripDetails.tripUsers[i].landmark.landmark + '</td></tr>').bindTooltip(i + 1 + "", {
                          permanent: true,
                          direction: "left",
                          offset: L.point(-10, 0)
                        })
                        .openTooltip();
                      return m;
                    }
                  } else {
                    if (i === 0) {
                      let m = L.marker(wp.latLng, {
                        icon: L.icon({
                          iconUrl: "./assets/images/company.png",
                          iconSize: [40, 40]
                        })
                      }).bindPopup(
                        tripDetailList[t].tripDetails.tripUsers[0].landmark.landmark
                      );
                      return m;
                    }
                    if (i - 1 <= tripDetailList[t].tripDetails.tripUsers.length) {
                      let m = L.marker(wp.latLng, {
                        icon: L.icon({
                          iconUrl: tripDetailList[t].tripDetails.tripUsers[i - 1].tripUser.userInfoDetails.gender === "Female"
                            ? "./assets/images/livetracking/femaleloc.svg" : "./assets/images/livetracking/maleloc.svg",
                          iconSize: [65, 70]
                        })
                      }).bindPopup('<tr><td>UserName : </td<td>' + tripDetailList[t].tripDetails.tripUsers[i - 1].tripUser
                        .userInfoDetails.displayName + '</td><br> <td>AL : </td><td>' +
                        tripDetailList[t].tripDetails.tripUsers[i - 1].landmark.area.area + ', ' +
                        tripDetailList[t].tripDetails.tripUsers[i - 1].landmark.landmark + '</td></tr>').bindTooltip(i + "", {
                          permanent: true,
                          direction: "left",
                          offset: L.point(-10, 0)
                        }).openTooltip();
                      return m;
                    }
                  }
                  op = op + 0.15;
                }
              }).addTo(this.map);
              r.setWaypoints(wps);
              r.hide();
            } else {
              this.showOnPrevMap(tripDetailList);
            }
          }
        } else {
          if (this.tripsList[t].tripDetails.tripUsers.length != 0 && k) {
            let r = L.Routing.control({
              serviceUrl: Constants.OSM_ROUTING_URL,
              showAlternatives: false,
              lineOptions: {
                styles: [{
                  color: this.colours[t],
                  weight: 3,
                  opacity: 0.8
                }]
              },
              fitSelectedRoutes: true,
              waypointMode: "connect",
              addWaypoints: false,
              draggableWaypoints: false,
              autoRoute: true,
              reverseWaypoints: false,
              show: true,
              routeWhileDragging: false,
              createMarker: (i, wp, nWps) => {
                if (success.body.trips[t].LOGTYPE === "IN") {
                  if (i === this.tripsList[t].tripDetails.tripUsers.length) {
                    let m = L.marker(wp.latLng, {
                      icon: L.icon({
                        iconUrl: "./assets/images/company.png",
                        iconSize: [40, 40]
                      })
                    }).bindPopup(
                      this.tripsList[t].tripDetails.tripUsers[
                        this.tripsList[t].tripDetails.tripUsers.length - 1
                      ].landmark.landmark
                    );
                    return m;
                  }
                  if (i < this.tripsList[t].tripDetails.tripUsers.length) {
                    let m = L.marker(wp.latLng, {
                      icon: L.icon({
                        iconUrl: this.tripsList[t].tripDetails.tripUsers[i].tripUser.userInfoDetails.gender === "Female"
                          ? "./assets/images/livetracking/femaleloc.svg" : "./assets/images/livetracking/maleloc.svg",
                        iconSize: [65, 70]
                      })
                    }).bindPopup('<tr><td>UserName : </td<td>' + this.tripsList[t].tripDetails.tripUsers[i].tripUser
                      .userInfoDetails.displayName + '</td><br> <td>AL : </td><td>' +
                      this.tripsList[t].tripDetails.tripUsers[i].landmark.area.area + ', ' +
                      this.tripsList[t].tripDetails.tripUsers[i].landmark.landmark + '</td></tr>').bindTooltip(i + 1 + "", {
                        permanent: true,
                        direction: "left",
                        offset: L.point(-10, 0)
                      })
                      .openTooltip();
                    return m;
                  }
                } else {
                  if (i === 0) {
                    let m = L.marker(wp.latLng, {
                      icon: L.icon({
                        iconUrl: "./assets/images/company.png",
                        iconSize: [40, 40]
                      })
                    }).bindPopup(
                      this.tripsList[t].tripDetails.tripUsers[0].landmark.landmark
                    );
                    return m;
                  }
                  if (i - 1 <= this.tripsList[t].tripDetails.tripUsers.length) {
                    let m = L.marker(wp.latLng, {
                      icon: L.icon({
                        iconUrl: this.tripsList[t].tripDetails.tripUsers[i - 1].tripUser.userInfoDetails.gender === "Female"
                          ? "./assets/images/livetracking/femaleloc.svg" : "./assets/images/livetracking/maleloc.svg",
                        iconSize: [65, 70]
                      })
                    }).bindPopup('<tr><td>UserName : </td<td>' + this.tripsList[t].tripDetails.tripUsers[i - 1].tripUser
                      .userInfoDetails.displayName + '</td><br> <td>AL : </td><td>' +
                      this.tripsList[t].tripDetails.tripUsers[i - 1].landmark.area.area + ', ' +
                      this.tripsList[t].tripDetails.tripUsers[i - 1].landmark.landmark + '</td></tr>').bindTooltip(i + "", {
                        permanent: true,
                        direction: "left",
                        offset: L.point(-10, 0)
                      }).openTooltip();
                    return m;
                  }
                }
                op = op + 0.15;
              }
            }).addTo(this.map);
            r.setWaypoints(wps);
            r.hide();
          } else {
            this.showOnPrevMap(tripDetailList);
          }
        }
      });

    }, error => {
      console.log(error);
      this.drawOsmLocalRoutes();
    }
    );
  }

  showOnPrevMap(tripDetailList) {
    this.clearGoogleRoutes();
    this.osmTripUsers = [];
    tripDetailList.forEach((element, t) => {
      if (element.tripDetails.tripUsers.length > 0) {
        const waypts = [];
        let startnodelatlng = {
          lat: element.tripDetails.site.landmark.latitude,
          lng: element.tripDetails.site.landmark.longitude
        };
        let endnodelatlng = {
          lat: element.tripDetails.site.landmark.latitude,
          lng: element.tripDetails.site.landmark.longitude
        };
        if (element.tripDetails.shift) {
          if (element.tripDetails.shift.logType == "IN") {
            startnodelatlng = {
              lat: element.tripDetails.tripUsers[0] ? element.tripDetails.tripUsers[0].landmark.latitude : element.tripDetails.site.landmark.latitude,
              lng: element.tripDetails.tripUsers[0] ? element.tripDetails.tripUsers[0].landmark.longitude : element.tripDetails.site.landmark.longitude
            };
          } else {
            endnodelatlng = {
              lat: element.tripDetails.tripUsers[element.tripDetails.tripUsers.length - 1].landmark.latitude,
              lng: element.tripDetails.tripUsers[element.tripDetails.tripUsers.length - 1].landmark.longitude
            };
          }
        }
        let markerlist = [];
        element.tripDetails.tripUsers.forEach((tripuser, tIndex) => {
          waypts.push({
            location: {
              lat: tripuser.landmark.latitude,
              lng: tripuser.landmark.longitude
            },
            stopover: true
          });
          let icon = "./assets/images/livetracking/maleloc.svg";
          if (tripuser.tripUser.userInfoDetails.gender == "Female") {
            icon = "./assets/images/livetracking/femaleloc.svg";
          }
          if (!this.isOsm) {
            var marker = new google.maps.Marker({
              position: {
                lat: tripuser.landmark.latitude,
                lng: tripuser.landmark.longitude
              },
              icon: this.getGoogleEmployeeIcon(icon),
              draggable: false,
              map: this.map,
              title: tripuser.tripUser.userInfoDetails.displayName + " - " + tripuser.routedOrder,
              label: {
                text: "P" + (tIndex + 1),
                color: "black",
                fontWeight: "bold",
                fontSize: "12px"
              }
            });
          }
          markerlist.push(marker);
          this.markers.push(marker);
        });
        this.osmTripUsers.push(element.tripDetails);
        this.tripempmarkers.push({
          tripid: element.tripDetails.tripId,
          markers: markerlist
        });
        if (this.sitemarker == undefined && !this.isOsm) {
          this.markSite(element.tripDetails.site);
        }
        if (!this.isOsm) {
          const isInTrip = element.tripDetails.shift?.logType == "IN";
          // Exclude origin/destination from waypoints — duplicating them skews Google Directions.
          const middleWaypts = isInTrip ? waypts.slice(1) : waypts.slice(0, -1);
          this.drawGoogleTripRoute({
            origin: startnodelatlng,
            destination: endnodelatlng,
            waypoints: middleWaypts,
            optimizeWaypoints: false,
            avoidHighways: false,
            avoidTolls: false,
            travelMode: google.maps.DirectionsTravelMode.DRIVING
          }, this.colours[t % this.colours.length], t === 0);
        }
      }
    });
    if (this.isOsm) {
      this.showExactRouteOnMp(tripDetailList);
    } else {
      this.ngxLoader.stop();
    }
  }

  showExactRouteOnMp(tripList) {
    let updatedColours = [...this.colours];
    let matchingIndex: any = [];
    this.tripsList.forEach((trip, index) => {
      const matchingTrip = tripList.find(t => t.id == trip.id);
      if (!matchingTrip) {
        matchingIndex.push(index);
      }
    });
    if (matchingIndex) {
      matchingIndex.sort((a, b) => b - a);
      matchingIndex.forEach(index => {
        if (index >= 0 && index < this.colours.length) {
          updatedColours.splice(index, 1);
        }
      });
    }
    const trips = [];
    const trips1: any = [];
    let op = 0.15;
    tripList.forEach(trip => {
      if (trip.tripDetails.tripUsers.length > 0) {
        trips.push(trip.tripDetails);
        trips1.push(trip);
      }
    });
    let tripDetailList = tripList.filter(trip => trip.tripDetails != null && trip.tripDetails.tripUsers != null && trip.tripDetails.tripUsers.length > 0);
    let k = true;
    const site: any = this.siteid;
    const siteId = this.tripsv3Flag ? site.split(",")[0] : this.siteid;
    const logType = this._tripModel.tripDetails?.shift?.logType || this.logType;
    this.apiService.doPostRequestWithResponse(ApiConstants.gettripmodifypreview + logType + '&siteid=' + siteId, trips, success => {
      success.body.trips.forEach((trips, t) => {
        let wps = [];
        trips.OSRM.waypoints.forEach(wp => {
          wps.push(L.latLng(wp.location[1], wp.location[0]));
        });
        if (tripDetailList[t].tripDetails.tripUsers.length != 0 && k) {
          let r = L.Routing.control({
            serviceUrl: Constants.OSM_ROUTING_URL,
            showAlternatives: false,
            lineOptions: {
              styles: [{
                color: updatedColours[t],
                weight: 3,
                opacity: 0.8
              }]
            },
            fitSelectedRoutes: true,
            waypointMode: "connect",
            addWaypoints: false,
            draggableWaypoints: false,
            autoRoute: true,
            reverseWaypoints: false,
            show: true,
            routeWhileDragging: false,
            createMarker: (i, wp, nWps) => {
              if (success.body.trips[t].LOGTYPE === "IN") {
                if (i === tripDetailList[t].tripDetails.tripUsers.length) {
                  let m = L.marker(wp.latLng, {
                    icon: L.icon({
                      iconUrl: "./assets/images/company.png",
                      iconSize: [40, 40]
                    })
                  }).bindPopup(
                    tripDetailList[t].tripDetails.tripUsers[
                      tripDetailList[t].tripDetails.tripUsers.length - 1
                    ].landmark.landmark
                  );
                  return m;
                }
                if (i < tripDetailList[t].tripDetails.tripUsers.length) {
                  let m = L.marker(wp.latLng, {
                    icon: L.icon({
                      iconUrl: tripDetailList[t].tripDetails.tripUsers[i].tripUser.userInfoDetails.gender === "Female"
                        ? "./assets/images/livetracking/femaleloc.svg" : "./assets/images/livetracking/maleloc.svg",
                      iconSize: [65, 70]
                    })
                  }).bindPopup('<tr><td>UserName : </td<td>' + tripDetailList[t].tripDetails.tripUsers[i].tripUser
                    .userInfoDetails.displayName + '</td><br> <td>AL : </td><td>' +
                    tripDetailList[t].tripDetails.tripUsers[i].landmark.area.area + ', ' +
                    tripDetailList[t].tripDetails.tripUsers[i].landmark.landmark + '</td></tr>').bindTooltip(i + 1 + "", {
                      permanent: true,
                      direction: "left",
                      offset: L.point(-10, 0)
                    })
                    .openTooltip();
                  return m;
                }
              } else {
                if (i === 0) {
                  let m = L.marker(wp.latLng, {
                    icon: L.icon({
                      iconUrl: "./assets/images/company.png",
                      iconSize: [40, 40]
                    })
                  }).bindPopup(
                    tripDetailList[t].tripDetails.tripUsers[0].landmark.landmark
                  );
                  return m;
                }
                if (i - 1 <= tripDetailList[t].tripDetails.tripUsers.length) {
                  let m = L.marker(wp.latLng, {
                    icon: L.icon({
                      iconUrl: tripDetailList[t].tripDetails.tripUsers[i - 1].tripUser.userInfoDetails.gender === "Female"
                        ? "./assets/images/livetracking/femaleloc.svg" : "./assets/images/livetracking/maleloc.svg",
                      iconSize: [65, 70]
                    })
                  }).bindPopup('<tr><td>UserName : </td<td>' + tripDetailList[t].tripDetails.tripUsers[i - 1].tripUser
                    .userInfoDetails.displayName + '</td><br> <td>AL : </td><td>' +
                    tripDetailList[t].tripDetails.tripUsers[i - 1].landmark.area.area + ', ' +
                    tripDetailList[t].tripDetails.tripUsers[i - 1].landmark.landmark + '</td></tr>').bindTooltip(i + "", {
                      permanent: true,
                      direction: "left",
                      offset: L.point(-10, 0)
                    }).openTooltip();
                  return m;
                }
              }
              op = op + 0.15;
            }
          }).addTo(this.map);
          r.setWaypoints(wps);
          r.hide();
        }
      });

    }, error => {
      console.log(error);
    }
    );
  }

  private getNextAddingNumber(): number {
    let nextId = -100;
    this.tripsList.forEach(trip => {
      const candidateIds = [Number(trip.id), Number(trip.tripDetails?.tripId)];
      const tripCode = String(trip.tripCode || trip.tripCodes || trip.tripDetails?.tripCode || '');
      if (tripCode.startsWith('ADD')) {
        candidateIds.push(Number(tripCode.slice(3)));
      } else if (tripCode.startsWith('-')) {
        candidateIds.push(Number(tripCode));
      }
      candidateIds.forEach(id => {
        if (!Number.isNaN(id) && id < 0 && id >= nextId) {
          nextId = id + 1;
        }
      });
    });
    return nextId;
  }

  private syncAddingNumberFromExistingTrips(): void {
    this.addingNumber = this.getNextAddingNumber();
  }

  addTrip() {
    if (this.isAddTripInProgress) {
      return;
    }
    if (!this.vehicleList?.length) {
      this.notifyService.showWarning('Vehicle types are not available yet', null);
      return;
    }

    const loadingStartedAt = Date.now();
    this.isAddTripInProgress = true;
    this.showAddTripLoading = true;
    this.clearAddTripLoadingTimer();
    this.cd.detectChanges();

    setTimeout(() => {
      try {
        if (this.autosaveFlag) {
          this.syncAddingNumberFromExistingTrips();
        }
        const firstVehicle = this.vehicleList[0];
        const newTripId = this.addingNumber;
        this.tripsList.push(Object.assign(new tripModel(), {
          id: newTripId,
          tripCode: `ADD${newTripId}`,
          ...(this.autosaveFlag ? { tripCodes: String(newTripId) } : {}),
          vehicleType: firstVehicle.vehicleType,
          vehicleTypeId: firstVehicle.id,
          vehicleCap: firstVehicle.seatCapacity,
          escortStatus: false,
          deviceTripStatus: "not started",
          tripDetails: {
            site: { landmark: this.siteData },
            tripUsers: []
          },
          usersList: []
        }));
        this.addingNumber++;
        this.tripDataTemp.push(this.tripsList[this.tripsList.length - 1]);
      } finally {
        const elapsed = Date.now() - loadingStartedAt;
        const remaining = this.addTripMinLoadingMs - elapsed;
        if (remaining > 0) {
          this.addTripLoadingTimer = setTimeout(() => this.finishAddTrip(), remaining);
        } else {
          this.finishAddTrip();
        }
      }
    }, 0);
  }

  private finishAddTrip() {
    this.clearAddTripLoadingTimer();
    this.isAddTripInProgress = false;
    this.showAddTripLoading = false;
    this.cd.markForCheck();
  }

  private clearAddTripLoadingTimer() {
    if (this.addTripLoadingTimer) {
      clearTimeout(this.addTripLoadingTimer);
      this.addTripLoadingTimer = null;
    }
  }

  escortClick(trip) {
    if (trip.tripDetails.tripUsers.length == trip.vehicleCap) {
      this.notifyService.showWarning("Please remove any one employee to enable escort", null);
    }
  }

  onExceptionDrop(user) {
    this.cd.reattach();
  }

  private getTripUserId(user: any): number | string {
    return user?.tripUser?.id ?? user?.id;
  }

  private findTripWithUser(userId: number | string, excludeTripId?: number | string): any {
    return this.tripsList.find(t =>
      t.id !== excludeTripId &&
      t.tripDetails.tripUsers.some(u => this.getTripUserId(u) === userId)
    );
  }

  private removeFromExceptionList(userId: number | string): void {
    this.exceptionEmps = this.exceptionEmps.filter(
      e => this.getTripUserId(e) !== userId
    );
  }

  private revertDuplicateDrop(trip: any, user: any, userId: number | string): void {
    const revert = () => {
      trip.tripDetails.tripUsers = trip.tripDetails.tripUsers.filter(
        u => this.getTripUserId(u) !== userId
      );
      this.removeFromExceptionList(userId);
      this.selectedUser = undefined;
      this.cd.markForCheck();
    };
    revert();
    setTimeout(revert, 100);
  }

  removeDumplicateValue(myArray, user, trip?) {
    var newArray = [];
    let flag = false;
    let tripCode = '';
    myArray.forEach((value) => {
      var exists = false;
      newArray.forEach((val2) => {
        if (this.getTripUserId(value) === this.getTripUserId(val2)) {
          exists = true;
          flag = true;
          const existingTrip = this.findTripWithUser(this.getTripUserId(val2));
          tripCode = val2.tripCode || trip?.tripCode || existingTrip?.tripCode || 'NA';
        }
      });
      if (!exists && this.getTripUserId(value) !== '') { newArray.push(value); }
    });
    if (!flag) {
      return myArray;
    }
    this.notifyService.showInfo(user.tripUser.userInfoDetails.displayName + " is already present in the " + tripCode, null);
    this.scheduleDropTimer(() => {
      this.removeFromExceptionList(this.getTripUserId(user));
      this.cd.markForCheck();
    }, 100);
    return newArray;
  }

  private clearDropTimers(): void {
    this.dropTimers.forEach(id => clearTimeout(id));
    this.dropTimers = [];
  }

  private scheduleDropTimer(fn: () => void, ms: number): void {
    const id = setTimeout(() => {
      this.dropTimers = this.dropTimers.filter(timerId => timerId !== id);
      fn();
    }, ms);
    this.dropTimers.push(id);
  }

  onItemDrop(trip, user, tripIndex) {
    this.clearDropTimers();
    this.dropMsg = true;
    user = this.selectedUser !== undefined ? this.selectedUser : user;
    const userId = this.getTripUserId(user);
    const existingTrip = this.findTripWithUser(userId, trip.id);
    if (existingTrip) {
      const tripCode = existingTrip.tripCode || 'NA';
      this.notifyService.showInfo(
        `${user.tripUser.userInfoDetails.displayName} is already present in the ${tripCode}`,
        null
      );
      this.revertDuplicateDrop(trip, user, userId);
      this.cd.reattach();
      return;
    }
    let escortCount = trip.escortStatus ? 1 : 0;
    let arr = [];
    this.tripsList.forEach((trips, t) => {
      arr = trips.tripDetails.tripUsers;
      trips.tripDetails.tripUsers = this.removeDumplicateValue(arr, user, trips);
      if (trip.id == trips.id) {
        // this.ngxLoader.start();
        if (trip.tripDetails.tripUsers.length + escortCount > trip.vehicleCap) {
          this.dropMsg = true;
          this.scheduleDropTimer(() => {
            this.notifyService.showWarning("Reached maximum seat capacity!", null);
            let index = this.tripsList[t].tripDetails.tripUsers.findIndex(
              u => this.getTripUserId(u) === userId
            );
            if (index > -1) {
              this.ngxLoader.stop();
              trips.tripDetails.tripUsers.splice(index, 1);
            }
          }, 600);
          if (!this.isExceptionDragged) {
            this.dropMsg = true;
            this.scheduleDropTimer(() => {
              this.ngxLoader.stop();
              this.tripsList[this._tripIndex].tripDetails.tripUsers.splice(
                this._userIndex,
                0,
                user
              );
              const uniqueUsersMap = new Map();
              this.tripsList[this._tripIndex].tripDetails.tripUsers.forEach(u => {
                uniqueUsersMap.set(this.getTripUserId(u), u);
              });
              this.tripsList[this._tripIndex].tripDetails.tripUsers = Array.from(uniqueUsersMap.values());
            }, 100);
          } else {
            this.scheduleDropTimer(() => {
              this.ngxLoader.stop();
              this.dropMsg = true;
              let objIndex = this.tripsList[t].tripDetails.tripUsers.findIndex(
                u => this.getTripUserId(u) === userId
              );
              if (objIndex > -1) {
                this.tripsList[t].tripDetails.tripUsers.splice(objIndex, 1);
                this.exceptionEmps.splice(this._userIndex, 0, user);
              }
              const uniqueUsersMap = new Map();
              this.exceptionEmps.forEach(emp => {
                uniqueUsersMap.set(this.getTripUserId(emp), emp);
              });
              this.exceptionEmps = Array.from(uniqueUsersMap.values());
            }, 100);
          }
        }
        this.scheduleDropTimer(() => {
          this.ngxLoader.stop();
        }, 600);
      }
    });
    if (this.isExceptionDragged) {
      const addedUser = trip.tripDetails.tripUsers.find(u => this.getTripUserId(u) === userId);
      if (addedUser) {
        addedUser.tripCode = trip.tripCode;
      }
      this.selectedUser = undefined;
    }
    this.cd.reattach();
  }

  dragEnded(trip, tIndex, uIndex) {
    this.cd.reattach();
  }

  dragStarted(trip, tripIndex, userIndex) {
    this.dropMsg = false;
    this.isExceptionDragged = false;
    this.toDropTrip = trip;
    this._tripIndex = tripIndex;
    this._userIndex = userIndex;
    const userData = trip.tripDetails.tripUsers[userIndex];
    if (!trip || !userData) {
      return;
    }
    const draggedId = this.getTripUserId(userData);
    this.scheduleDropTimer(() => {
      if (this.dropMsg) {
        return;
      }
      let removeUser = false;
      for (let i = 0; i < this.tripsList.length; i++) {
        const data = this.tripsList[i];
        const escortCount = data.escortStatus ? 1 : 0;
        if (data.tripDetails.tripUsers.length + escortCount > data.vehicleCap) {
          const foundIndex = data.tripDetails.tripUsers.findIndex(user => this.getTripUserId(user) === draggedId);
          if (foundIndex !== -1) {
            removeUser = true;
            data.tripDetails.tripUsers.splice(foundIndex, 1);
            this.notifyService.showWarning("Reached maximum seat capacity!", null);
            break;
          }
        }
      }
      if (removeUser) {
        trip.tripDetails.tripUsers.splice(0, 0, userData);
        const uniqueUsersMap = new Map();
        trip.tripDetails.tripUsers.forEach(user => {
          uniqueUsersMap.set(this.getTripUserId(user), user);
        });
        trip.tripDetails.tripUsers = Array.from(uniqueUsersMap.values());
      }
    }, 1000);
  }

  exceptionDragStarted(user, index) {
    this.dropMsg = false;
    this.selectedUser = user;
    this.removeUser = '';
    this.isExceptionDragged = true;
    this.toDropException = user;
    this._userIndex = index;
    this.cd.reattach();

    this.scheduleDropTimer(() => {
      if (this.dropMsg) {
        return;
      }
      const draggedId = this.getTripUserId(user);
      this.tripsList.forEach((trip, i) => {
        const matched = trip.tripDetails.tripUsers.some(ele => this.getTripUserId(ele) === draggedId);
        if (!matched) {
          return;
        }
        const escortCount = trip.escortStatus ? 1 : 0;
        if (this.tripsList[i].tripDetails.tripUsers.length + escortCount > this.tripsList[i].vehicleCap) {
          this.scheduleDropTimer(() => this.exceptionUserDrop(user), 600);
        }
      });
    }, 600);
  }

  exceptionUserDrop(user) {
    this.ngxLoader.stop();
    this.tripsList.forEach((trip, t) => {
      trip.tripDetails.tripUsers.forEach((ele1) => {
        if (this.getTripUserId(ele1) === this.getTripUserId(user)) {
          let escortCount = trip.escortStatus ? 1 : 0;
          let findIndex = this.tripsList[t].tripDetails.tripUsers.indexOf(ele1);
          if (findIndex > -1 && (this.tripsList[t].tripDetails.tripUsers.length + escortCount > this.tripsList[t].vehicleCap)) {
            this.notifyService.showWarning("Reached maximum seat capacity!", null);
            this.tripsList[t].tripDetails.tripUsers.splice(findIndex, 1);
            this.exceptionEmps.splice(this._userIndex, 0, ele1);
            const uniqueUsersMap = new Map();
            this.exceptionEmps.forEach(emp => {
              uniqueUsersMap.set(this.getTripUserId(emp), emp);
            });
            this.exceptionEmps = Array.from(uniqueUsersMap.values());
          }
        }
      });
    });
  }

  dragEndTrips(event, trip) { }

  getSite() {
    const site: any = this.siteid;
    const siteId = this.tripsv3Flag ? site.split(",")[0] : this.siteid;
    this.apiService.doGetRequestWithResponse(ApiConstants.siteDetailsForaddingAL + siteId, success => {
      this.siteData = success.body.landmark;
      this.getVehicleTypes();
    }, error => {
      console.log(error);
    });
  }

  getVehicleTypes() {
    const site: any = this.siteid;
    const siteId = this.tripsv3Flag ? site.split(",")[0] : this.siteid;
    this.apiService.doGetRequestWithResponse(ApiConstants.getVehicleTypesBySiteId + "?siteId=" + siteId,
      success => {
        if (success.status == 200) {
          this.vehicleList = success.body;
        } else if (success.status == 204) {
          this.vehicleList = [];
        }
        if (this.addTripOnly) {
          this.initializeAddTripMode();
        }
      },
      error => {
        console.log(error);
      }
    );
  }

  private initializeAddTripMode(): void {
    this.addTrip();
    if (this.autosaveFlag) {
      this.startAutoSaveInterval();
    }
  }

  // SelectedVehicle(vehicleid, trip) {
  //   this.tripsList.forEach(tt => {
  //     if (tt.tripCode == trip.tripCode) {
  //       this.vehicleList.forEach(veh => {
  //         if (veh.id == vehicleid) {
  //           let escortCount = 0;
  //           if (trip.escortStatus) {
  //             escortCount = 1;
  //           }
  //           if (trip.tripDetails.tripUsers.length <= veh.seatCapacity) {
  //             tt.vehicleCap = veh.seatCapacity;
  //             tt.vehicleType = veh.vehicleType;
  //             tt.vehicleTypeId = veh.id;
  //           } else {
  //             this.notifyService.showInfo("Seat capacity is less than employee occupied", null);
  //           }
  //         }
  //       });
  //     }
  //   });
  // }

  SelectedVehicle(vehicleid, trip) {
    const targetTrip = this.tripsList.find(tt => tt.tripCode === trip.tripCode);
    const selectedVehicle = this.vehicleList.find(veh => veh.id === vehicleid);
    if (!targetTrip || !selectedVehicle) return;
    if (trip.tripDetails.tripUsers.length <= selectedVehicle.seatCapacity) {
      Object.assign(targetTrip, {
        vehicleCap: selectedVehicle.seatCapacity,
        vehicleType: selectedVehicle.vehicleType,
        vehicleTypeId: selectedVehicle.id
      });
    } else {
      this.notifyService.showInfo("Seat capacity is less than employee occupied", null);
    }
  }

  escortChange(flag, trip) {
    const previousStatus = trip.escortStatus;
    const targetTrip = this.tripsList.find(tt => tt.tripCode === trip.tripCode);
    if (targetTrip) {
      targetTrip.escortStatus = flag;
      targetTrip.tripDetails.escortStatus = flag;
    }
    if (this.isNewTrip(trip)) {
      return;
    }
    this.updateEscortStatusByAdmin(trip.id, flag, trip.tripCode, previousStatus);
  }

  validateExceptionEmps() {
    return this.exceptionEmps.length === 0 || confirm("Are you sure to save with exception employees? ");
  }

  modificationConfirmation() {
    const dialogRef = this.dialog.open(ModifyConfirmationComponent, {
      width: "600px",
      disableClose: true,
      data: { text: "Do you want this trip modification in Master route?" }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.masterFlag = !!result;
      this.masterRouteName = result || null;
      if (!result || result !== -1) {
        this.save();
      }
    });
  }

  autoSeqDialog() {
    if (this.addTripOnly && this.tripsList?.length === 1 && !this.tripsList[0].tripDetails?.tripUsers?.length) {
      this.notifyService.showWarning('Please add at least one user to the trip before saving.', null);
      return;
    }
    let msg = "This save will auto-sequence the employees in the route!!";
    let msgKey = '';
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-success',
        cancelButton: 'btn btn-danger ms-2'
      },
      buttonsStyling: false
    });
    swalWithBootstrapButtons.fire({
      title: msg,
      text: msgKey,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      confirmButtonColor: '#34c38f',
      cancelButtonColor: '#f46a6a',
    }).then(result => {
      if (result.value) {
        swalWithBootstrapButtons.fire('Done', msgKey, 'success');
        this.autoSeqFlag = true;
        this.modificationConfirmation();
      } else {
        swalWithBootstrapButtons.fire('Cancelled', 'Not Updated', 'error');
        this.autoSeqFlag = false;
        this.modificationConfirmation();
      }
    });
  }

  // validateTripEscort() {
  //   const hasUnescortedFemale = this.tripsList.some(trip => {
  //     if (trip.deviceTripStatus !== "not started" || !trip.tripDetails.tripUsers.length || !trip.tripDetails.shift || trip.escortStatus) {
  //       return false;
  //     }

  //     const targetUser = trip.tripDetails.shift.logType === "OUT" 
  //       ? trip.tripDetails.tripUsers[trip.tripDetails.tripUsers.length - 1]
  //       : trip.tripDetails.tripUsers[0];

  //     return targetUser.tripUser.userInfoDetails.gender === "Female";
  //   });

  //   return !hasUnescortedFemale || confirm("Are you sure you want to save without escort for female employee?");
  // }

  formatDatePickerDate(d) {
    let date = d.split("/");
    let dd = date[2] + "-" + date[1] + "-" + date[0] + " 00:00:00";
    return formatDate(dd, "yyyy-MM-dd HH:mm:ss", "en-US");
  }

  getSiteIdArray(): any[] {
    let siteIds = [];
    const selectedSite: any = this.siteid;
    selectedSite.split(",").forEach(site => {
      siteIds.push(Number(site));
    });
    return siteIds;
  }

  private isNewTrip(trip: tripModel): boolean {
    const tripCode = String(trip.tripCode || trip.tripCodes || trip.tripDetails?.tripCode || '');
    const tripId = Number(trip.id ?? trip.tripDetails?.tripId);
    return tripCode.startsWith('ADD') || tripCode.startsWith('-') || tripId < 0;
  }

  private buildModifiedListForTrips(trips: tripModel[], autoSeqFlag: boolean = false, forAutoSave: boolean = false): any[] {
    const selectedSite: any = this.siteid;
    const modifiedList: any[] = [];
    trips.forEach(trip => {
      if (trip.deviceTripStatus !== "not started" && !this.allowModifyRunningTrip) {
        return;
      }
      const capacityOk = (trip.tripDetails.escortStatus && trip.vehicleCap > trip.tripDetails.tripUsers.length)
        || (!trip.tripDetails.escortStatus && trip.vehicleCap + 1 > trip.tripDetails.tripUsers.length);
      if (!capacityOk) {
        return;
      }
      let torder = 1;
      const userTripList = [];
      trip.tripDetails.tripUsers.forEach(tuser => {
        userTripList.push({
          userid: tuser.tripUser.id,
          routedOrder: torder,
          pickupDropTime: tuser.pickupDropTime ? tuser.pickupDropTime : null
        });
        torder++;
      });
      const tripPayload: any = {
        escortallocation: trip.escortStatus,
        shiftTimeId: this.shiftid,
        siteId: this.tripsv3Flag ? selectedSite.split(",")[0] : this.siteid,
        tripDate: this.formatDatePickerDate(this.date),
        vehicletypeid: trip.vehicleTypeId,
        tripusers: userTripList,
        tripId: trip.id,
        autoSeqFlag
      };
      if (forAutoSave) {
        tripPayload.isAddingTrip = this.isNewTrip(trip);
      }
      modifiedList.push(tripPayload);
    });
    return modifiedList;
  }

  private getExceptionEmployeeTripCode(emp: any): string {
    return String(emp.tripCode || emp.tripDetails?.tripCode || '');
  }

  private getExceptionListForModifySave(): any[] {
    if (!this.autosaveFlag) {
      return this.exceptionEmps;
    }
    return this.exceptionEmps.filter(emp => !this.getExceptionEmployeeTripCode(emp).includes('-'));
  }

  private buildModifyTripRequestData(trips: tripModel[], autoSeqFlag: boolean = false, forAutoSave: boolean = false): any {
    const reqData: any = {
      modifiedList: this.buildModifiedListForTrips(trips, autoSeqFlag, forAutoSave),
      exceptionList: this.exceptionEmps,
      masterFlag: this.masterFlag,
      uploadModification: this.uploadModification,
      updatePickupTime: this.updatePickupTime
    };
    if (this.tripsv3Flag) {
      reqData.siteIds = this.getSiteIdArray();
    }
    return reqData;
  }

  onAutoSaveClick() {
    if (!this.autosaveFlag) {
      return;
    }
    if (!this.tripsList?.length) {
      this.notifyService.showInfo('No trips to save', null);
      return;
    }
    const reqData = this.buildModifyTripRequestData(this.tripsList, false, true);
    if (!reqData.modifiedList.length) {
      this.notifyService.showInfo('No trips available to auto save', null);
      return;
    }
    this.ngxLoader.start();
    this.apiService.doPostRequestWithResponse(
      ApiConstants.autoSaveModifyTrips,
      reqData,
      success => {
        this.ngxLoader.stop();
        if (success.status === 200) {
          if (success.body?.errorMsg) {
            this.notifyService.showError(success.body.errorMsg, null);
          } else {
            this.notifyService.showSuccess('Trip modifications auto saved', null);
          }
        } else {
          this.notifyService.showWarning('Auto save failed', null);
        }
      },
      error => {
        this.ngxLoader.stop();
        this.notifyService.showError('Auto save failed', null);
        console.log('auto save modify trip:', error);
      }
    );
  }

  save() {
    this.ngxLoader.start();
    if (this.validateExceptionEmps()) {
      let removeEmpflag = true;
      let driverstatusflag = true;
      let userName = "";
      let driverstatus = "";
      let locTripCode = "";
      this.tripsList.forEach(trip => {
        const isRunningTrip = trip.deviceTripStatus !== "not started";
        if (isRunningTrip && !this.allowModifyRunningTrip) {
          driverstatusflag = false;
          locTripCode = trip.tripCode;
          driverstatus = trip.deviceTripStatus;
          return;
        }
        const capacityOk = (trip.tripDetails.escortStatus && trip.vehicleCap > trip.tripDetails.tripUsers.length)
          || (!trip.tripDetails.escortStatus && trip.vehicleCap + 1 > trip.tripDetails.tripUsers.length);
        if (!capacityOk) {
          removeEmpflag = false;
          locTripCode = trip.tripCode;
        }
        trip.tripDetails.tripUsers.forEach(tuser => {
          if (tuser.tripUser.id != tuser.tripUser.userInfoDetails.id) {
            userName = tuser.tripUser.userInfoDetails.displayName;
          }
        });
      });
      if (removeEmpflag && driverstatusflag) {
        const reqData = this.buildModifyTripRequestData(this.tripsList, this.autoSeqFlag);
        reqData.exceptionList = this.getExceptionListForModifySave();
        const endPoint = this.tripsv3Flag ? ApiConstants.modifytripsV3 : ApiConstants.modifytrip;
        this.apiService.doPostRequestWithResponse(endPoint, reqData, success => {
          if (success.status == 200) {
            if (success.body.errorMsg) {
              this.ngxLoader.stop();
              this.notifyService.showError(success.body.errorMsg, null);
            } else {
              this.ngxLoader.stop();
              this.stopAutoSaveInterval();
              this.notifyService.showSuccess("Trips Modified", null);
              this.onClickBack();
            }
          } else if (success.status == 204) {
            this.ngxLoader.stop();
            this.notifyService.showInfo("Can't Modify running trip ", null);
          }
        }, error => {
          this.ngxLoader.stop();
          if ((error.status && error.status == 504) || error.message == "Request Timed out, Please try again later" || error.message == "Network error occured. Please try again later.") {
            this.notifyService.showWarning("Please wait, modification is been processed in the background...", null)
            this.onClickBack();
          } else {
            if (userName != "") {
              this.notifyService.showWarning(userName + " has not enough data. " + locTripCode + " modified failed", null)
            } else {
              this.notifyService.showWarning("Trip modified failed", null)
            }
          }
        });
      } else if (!driverstatusflag) {
        this.ngxLoader.stop();
        this.notifyService.showInfo(locTripCode + " can't modify.trip is already " + driverstatus, null);
      } else {
        this.ngxLoader.stop();
        this.notifyService.showWarning("Seat Capacity exceeded, Please remove employees from trip : " + locTripCode, null);
      }
    } else {
      this.ngxLoader.stop();
    }
  }

  preViewMap() {
    this.toggleMapDisplay();
    if (this.isOsm) {
      this.loadOpenStreetMap();
      this.showOnMap();
    } else {
      this.loadGoogleMap(() => this.showOnMap());
    }
  }

  toggleMapDisplay() {
    if (this.height === "0px") {
      this.height = "400px";
      this.panelBody = this.exceptionPanelHeightWithMap;
      this.title = "Hide Map";
      this.icon = "assets/images/hide.svg";
    }
  }

  private syncExceptionPanelHeight() {
    this.panelBody = this.height === "0px"
      ? this.exceptionPanelHeightWithoutMap
      : this.exceptionPanelHeightWithMap;
  }

  loadOpenStreetMap() {
    this.map?.remove();
    this.googleMapInitialized = false;
    this.searchBox = null;
    this.showGoogleSearch = false;
    this.loadOsmap();
  }

  loadGoogleMap(afterInit?: () => void) {
    this.clearMarker();
    this.googleMapInitialized = false;
    this.searchBox = null;
    this.showGoogleSearch = false;
    this.mapLoadAttempts = 0;
    this.loadgmap(() => {
      if (this.tripdetails[0]?.tripDetails?.site) {
        this.markSite(this.tripdetails[0].tripDetails.site);
      }
      afterInit?.();
    });
  }

  clearMarker() {
    this.markers.forEach(marker => {
      marker.setMap(null);
    });
    this.markers = [];
    if (this.googleSearchMarker) {
      this.googleSearchMarker.setMap(null);
      this.googleSearchMarker = null;
    }
    this.clearGoogleRoutes();
  }

  dragHandler(event) {
    var offset = 150;
    var scrollValueDown = 10;
    var scrollValueUp = -1 * scrollValueDown;
    if (event.screenY > 0 && event.screenY < offset) {
      window.scrollBy(0, scrollValueUp); // up
    }
    if (event.screenY > window.outerHeight - offset && event.screenY < window.outerHeight) {
      window.scrollBy(0, scrollValueDown); // down
    }
  }

  editZone(trip) {
    if (trip.tripDetails.zone != null) {
      this.router.navigateByUrl("/myatom/routing/editzone/" + trip.id);
    } else {
      this.notifyService.showInfo("No zone found", null);
    }
  }

  // removeUserFromTrips(trip, user, d) {
  //   this.removeUser = '';
  //   if (trip) {
  //     this.removeUser = trip.id;
  //   }
  //   this.cd.reattach();
  //   let escortCount = 0;
  //   let arr = [];
  //   if (trip.escortStatus) {
  //     escortCount = 1;
  //   }
  //   this.tripsList.forEach((trips, t) => {
  //     arr = trips.tripDetails.tripUsers;
  //     trips.tripDetails.tripUsers = this.removeDumplicateValue(arr, user);
  //     if (trip.id == trips.id) {
  //       this.tripsList[t].tripDetails.tripUsers.splice(
  //         this.tripsList[t].tripDetails.tripUsers.indexOf(user), 1);
  //       this.exceptionEmps.splice(this._userIndex, 0, user);
  //     }
  //   });
  // }

  removeUserFromTrips(trip, user, d) {
    this.removeUser = trip?.id || '';
    this.cd.reattach();
    this.tripsList.forEach((trips, t) => {
      trips.tripDetails.tripUsers = this.removeDumplicateValue(trips.tripDetails.tripUsers, user, trips);
      if (trip.id === trips.id) {
        const userIndex = this.tripsList[t].tripDetails.tripUsers.indexOf(user);
        if (userIndex > -1) {
          this.tripsList[t].tripDetails.tripUsers.splice(userIndex, 1);
          this.exceptionEmps.splice(0, 0, user);
        }
      }
    });
  }

  updateEscortStatusByAdmin(tripId, status, tripCode, previousStatus) {
    const revertEscortStatus = () => {
      const targetTrip = this.tripsList.find(tt => tt.tripCode === tripCode);
      if (targetTrip) {
        targetTrip.escortStatus = previousStatus;
        targetTrip.tripDetails.escortStatus = previousStatus;
      }
    };

    this.apiService.doPutRequestWithResponse(ApiConstants.updateEscortStatusByAdmin + tripId + '&estatus=' + status, '', success => {
      if (success.status == 200) {
        if (success.body.message == 'Escort status updated Successfully.') {
          this.notifyService.showSuccess(success.body.message, null);
        } else {
          revertEscortStatus();
          this.notifyService.showError(success.body.message, null);
        }
      } else {
        revertEscortStatus();
      }
    }, error => {
      revertEscortStatus();
      console.log("escort status update:", error);
    })
  }

  onClickMap() {
    if (this.height === "0px") {
      this.height = "400px";
      this.title = "Hide Map";
      this.icon = "assets/images/hide.svg";
      this.syncExceptionPanelHeight();
      this.cd.detectChanges();
      setTimeout(() => {
        this.refreshMapSize();
        if (!this.isOsm) {
          this.searchBox = null;
          this.googleSearchControlAttached = false;
          this.attachGoogleSearchControl('trip-modify-google-search');
        }
      }, 0);
    } else {
      this.height = "0px";
      this.title = "Show Map";
      this.icon = "assets/images/red-eye.svg"
      this.searchBox = null;
      this.showGoogleSearch = false;
      this.googleSearchControlAttached = false;
      this.syncExceptionPanelHeight();
    }
  }

  private refreshMapSize() {
    if (!this.map) {
      return;
    }
    if (this.isOsm) {
      this.map.invalidateSize();
    } else {
      google.maps.event.trigger(this.map, 'resize');
      this.map.setCenter({ lat: this.lat, lng: this.lng });
    }
  }

  onSearchKey(searchKey) {
    this.rebuildRoutedUserSearchIndex();
    const term = searchKey?.trim().toLowerCase();
    if (!term) {
      this.dataFlag = false;
      this.tripsList = this.tripDataTemp;
      this.tempData = [];
      this.userSelected = '';
      return;
    }
    this.dataFlag = true;
    this.tempData = this.tempDataSearch.filter(user => this.matchesRoutedUserSearch(user, term));
  }

  private rebuildRoutedUserSearchIndex() {
    const userMap = new Map<string, usersListModel>();
    this.tripDataTemp.forEach(trip => {
      trip.usersList?.forEach(user => {
        const key = `${user.personalNumber ?? ''}-${user.userName ?? ''}`;
        if (!userMap.has(key)) {
          userMap.set(key, user);
        }
      });
    });
    this.tempDataSearch = Array.from(userMap.values());
  }

  private matchesRoutedUserSearch(user: usersListModel, term: string): boolean {
    return (user.userName ?? '').toLowerCase().includes(term)
      || String(user.userId ?? '').toLowerCase().includes(term)
      || String(user.personalNumber ?? '').toLowerCase().includes(term);
  }

  // searchSelected(value) {
  //   this.tripsList = this.tripDataTemp;
  //   this.userSelected = value.userName;
  //   let valueArray = [];
  //   this.tripsList.forEach(e1 => {
  //     e1.usersList.forEach(e2 => {
  //       if ((e2.userName == value.userName) && (e2.personalNumber == value.personalNumber)) {
  //         valueArray.push(e1);
  //         this.tripsList = [];
  //         this.tripsList = valueArray;
  //       }
  //     })
  //   })
  // }

  searchSelected(value, event?: { source?: { selected?: boolean } }) {
    if (event?.source?.selected === false) {
      return;
    }
    this.userSelected = value.userName;
    this.tripsList = this.tripDataTemp.filter(trip =>
      trip.usersList.some(user =>
        user.userName === value.userName && user.personalNumber === value.personalNumber
      )
    );
  }

  // removeDel() {
  //   this.exceptionEmps ??= [];
  //   this.tripsList.forEach(trip => {
  //     const tripUsers = trip.tripDetails?.tripUsers;
  //     if (!tripUsers?.length) return;
  //     const [cancelledUsers, activeUsers] = tripUsers.reduce(
  //       ([cancelled, active], user) => {
  //         return user.showStatus === 'Cancel'
  //           ? [[...cancelled, user], active]
  //           : [cancelled, [...active, user]];
  //       },
  //       [[], []]
  //     );
  //     this.exceptionEmps.push(...cancelledUsers);
  //     trip.tripDetails.tripUsers = activeUsers;
  //   });
  // }

  removeDel() {
    this.exceptionEmps ??= [];
    this.tripsList.forEach(trip => {
      const tripUsers = trip.tripDetails?.tripUsers;
      if (!tripUsers?.length) return;
      const cancelledUsers = tripUsers.filter(user => user.showStatus === 'Cancel');
      this.exceptionEmps.push(...cancelledUsers);
      trip.tripDetails.tripUsers = tripUsers.filter(user => user.showStatus !== 'Cancel');
    });
  }

  onFileChanges($event) {
    const files = $event.target.files;
    if (!files?.length) return;
    const file = files[0];
    const fileExt = file.name.split(".").pop()?.toLowerCase();
    if (fileExt !== 'xlsx' && fileExt !== 'xls') {
      this.notifyService.showWarning("Please upload a valid Excel file (.xlsx or .xls)", null);
      this.fileUploadChange = "";
      return;
    }
    this.isFileUploaded = true;
    this.ngxLoader.start();
    const formData = new FormData();
    formData.append('file', file);
    formData.append('tripCount', this.totalTripCount);
    if (!this.tripsv3Flag) {
      formData.append('siteId', this.siteid.toString());
      formData.append('tripUserCount', this.totalTripUserCount);
    }

    const endPoint = this.tripsv3Flag ? ApiConstants.tripsV3Upload : ApiConstants.modifytripdetails;
    this.apiService.doPostFile(
      endPoint,
      formData,
      success => {
        this.ngxLoader.stop();
        if (success && success[0].error) {
          this.dialog.open(UploadExcelErrorDisplayComponent, {
            data: success[0].error,
            height: "400px",
            width: "700px",
            disableClose: true
          });
        } else {
          this.uploadModification = true;
          this.notifyService.showSuccess("Uploaded successfully", null);
          this.tripsList = [];
          this.uploadedTripData = success;
          this.tripdetails = success[0];
          // success[0].forEach((trip, tripIndex) => {
          //   this._tripModel = new tripModel();
          //   this._tripModel.id = trip.tripDetails.tripId;
          //   this._tripModel.tripCode = trip.tripDetails.tripCode == null ? "NA" : trip.tripDetails.tripCode.slice(0, 4) + trip.tripDetails.tripCode.slice(-4);
          //   this._tripModel.vehicleTypeId = trip.vehicleType.id;
          //   this._tripModel.vehicleType = trip.vehicleType.vehicleType;
          //   this._tripModel.escortStatus = trip.tripDetails.escortStatus;
          //   this._tripModel.vehicleCap = trip.vehicleType.seatCapacity;
          //   this._tripModel.tripDetails = trip.tripDetails;
          //   this._tripModel.deviceTripStatus = trip.DeviceTripStatus;
          //   this._tripModel.tripCodes = trip.tripDetails.tripCode || 'NA';
          //   this._tripUserModelList = [];
          //   let order = 1;
          //   trip.tripDetails.tripUsers.forEach(user => {
          //     user.currentStatus = trip.tripDetails.tripId;
          //     user.tripCode = trip.tripDetails.tripCode == null ? "NA" : trip.tripDetails.tripCode.slice(0, 4) + trip.tripDetails.tripCode.slice(-4);
          //     this._tripuserModel = new usersListModel();
          //     this._tripuserModel.userId = user.tripUser.id;
          //     this._tripuserModel.userName = user.tripUser.userInfoDetails.displayName;
          //     this._tripuserModel.routedOrder = order;
          //     this._tripuserModel.personalNumber = user.tripUser.userInfoDetails.employeeId;
          //     this._tripuserModel.address = user.landmark.area.area;
          //     this._tripUserModelList.push(this._tripuserModel);
          //     this._tripuserModel.showStatus = user.showStatus || 'N/A';
          //     this._tripuserModel.gender = user.tripUser.userInfoDetails.gender;
          //     this._tripuserModel.useraddress = user.tripUser.userInfoDetails.address || 'NA';
          //     this._tripuserModel.landMark = user.userLandmark.landmark || 'NA';
          //     this._tripuserModel.area = user.userLandmark.area?.area || 'NA';
          //     order++;
          //   });
          //   this._tripModel.usersList = this._tripUserModelList;
          //   this.tripsList.push(this._tripModel);
          //   this.tripDataTemp.push(this._tripModel);
          //   this.tempData.push(this._tripuserModel);
          //   this.tempDataSearch.push(this._tripuserModel);
          //   this.cd.markForCheck();
          // });

          success[0].forEach((trip, tripIndex) => {
            const tripCode = trip.tripDetails.tripCode ?
              this.formatTripCode(trip.tripDetails.tripCode) : "NA";
            this._tripModel = Object.assign(new tripModel(), {
              id: trip.tripDetails.tripId,
              tripCode,
              vehicleTypeId: trip.vehicleType.id,
              vehicleType: trip.vehicleType.vehicleType,
              escortStatus: trip.tripDetails.escortStatus,
              vehicleCap: trip.vehicleType.seatCapacity,
              tripDetails: trip.tripDetails,
              deviceTripStatus: trip.DeviceTripStatus,
              tripCodes: trip.tripDetails.tripCode || 'NA'
            });
            this._tripUserModelList = trip.tripDetails.tripUsers.map((user, index) => {
              user.currentStatus = trip.tripDetails.tripId;
              user.tripCode = tripCode;
              return Object.assign(new usersListModel(), {
                userId: user.tripUser.id,
                userName: user.tripUser.userInfoDetails.displayName,
                routedOrder: index + 1,
                personalNumber: user.tripUser.userInfoDetails.employeeId,
                address: user.landmark.area.area,
                showStatus: user.showStatus || 'N/A',
                gender: user.tripUser.userInfoDetails.gender,
                useraddress: user.tripUser.userInfoDetails.address || 'NA',
                landMark: user.userLandmark.landmark || 'NA',
                area: user.userLandmark.area?.area || 'NA',
                areaPickUpDrop: user.tripUser.userInfoDetails.pickUpDrop.area?.area || 'NA',
                landmarkPickUpDrop: user.tripUser.userInfoDetails.pickUpDrop.landmark || 'NA',
                designationName: user.tripUser.userInfoDetails.designationName || 'NA'
              });
            });

            this._tripModel.usersList = this._tripUserModelList;
            this.tripsList.push(this._tripModel);
            this.tripDataTemp.push(this._tripModel);
            this.cd.markForCheck();
          });
          this.rebuildRoutedUserSearchIndex();
          this.ngxLoader.stop();
          this.showOnMap();
        }
      },
      error => {
        this.ngxLoader.stop();
        this.fileUploadChange = "";
      }
    );
  }

  downloadModification(): void {
    const exceldata: any[][] = [];
    const tripHeaderIndexes: number[] = [];
    this.tripsList.forEach((element) => {
      tripHeaderIndexes.push(exceldata.length);
      const tripCode = this.tripsv3Flag
        ? (element.tripCodes ? `${element.tripCodes}-${element.tripDetails.site.siteName || ''}` : '')
        : (element.tripCodes || '');

      exceldata.push([
        tripCode,
        `VehicleType-${element.vehicleType || ''}`,
        `Escort-${element.escortStatus === true ? 'Yes' : 'No'}`,
        // 'Address',
        // 'Area',
        // 'Landmark',
        // 'Pickup/drop Time',
        // ...(this.isDesignation ? ['Designation'] : []),
      ]);

      // Add user rows with unique identifiers to prevent duplicates
      const processedUsers = new Set();
      element.tripDetails.tripUsers.forEach(tripUser => {
        element.usersList.forEach(emp => {
          const userKey = `${emp.personalNumber}-${emp.userName}`;
          if (!processedUsers.has(userKey)) {
            processedUsers.add(userKey);
            exceldata.push([
              emp.personalNumber || '',
              // emp.userName || '',
              // emp.gender === 'Male' ? 'M' : emp.gender === 'Female' ? 'F' : 'O',
              // emp.useraddress || '',
              // emp.areaPickUpDrop || '',
              // emp.landmarkPickUpDrop || '',
              tripUser.pickupDropTime || '',
              // ...(this.isDesignation ? [emp.designationName || ''] : []),
            ]);
          }
        });
      });
    });

    // const referenceSheet: any[][] = [
    //   ['TripCode', 'VehicleType', 'EscortRequired', 'Address', 'Area', 'LandMark', 'Pickup/drop Time', ...(this.isDesignation ? ['Designation'] : [])],
    //   ['EmployeeId', 'EmployeeName', 'Gender', '', '', '', '', ...(this.isDesignation ? [''] : [])]
    // ];

    const referenceSheet: any[][] = [
      ['TripCode', 'VehicleType', 'EscortRequired'],
      ['EmployeeId', '']
    ];

    const worksheet = XLSX.utils.aoa_to_sheet(exceldata);
    const reference = XLSX.utils.aoa_to_sheet(referenceSheet);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Modification Trips');
    XLSX.utils.book_append_sheet(workbook, reference, 'Reference');
    const wbout = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    XlsxPopulate.fromDataAsync(wbout).then(workbook => {
      const sheet = workbook.sheet('Modification Trips');
      // const columnCount = this.isDesignation ? 8 : 7;
      const columnCount = 3;
      // const timeColumnIndex = 7; // Pickup/drop Time column
      const timeColumnIndex = 2; // Pickup/drop Time column
      for (let i = 1; i <= columnCount; i++) {
        // sheet.column(i).width(i === 4 ? 21.25 : 17);
        sheet.column(i).width(17);
      }

      // Format the time column as text
      sheet.column(timeColumnIndex).style({ numberFormat: '@' });

      tripHeaderIndexes.forEach(rowIndex => {
        for (let col = 1; col <= columnCount; col++) {
          sheet.cell(rowIndex + 1, col).style({
            fill: 'FFFF00',
            wrapText: true,
            horizontalAlignment: 'center',
            verticalAlignment: 'center',
            bold: false
          });
        }
      });

      sheet.usedRange().style({ wrapText: true });
      workbook.outputAsync().then(blob => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'Modification.xlsx';
        a.click();
        window.URL.revokeObjectURL(url);
      });
    });
  }

  searchExceptionEmp(event) {
    const searchKey = event.target.value?.trim();
    if (!searchKey || searchKey.length < 3) {
      this.exceptionUsersList = [];
      this.exceptionUsersListDD = [];
      return;
    }
    this.getAllUsers(searchKey);
  }

  clearExceptionUserSearch() {
    this.userSearchkey = '';
    this.exceptionUsersList = [];
    this.exceptionUsersListDD = [];
  }

  searchTrips(event) {
    this.routedUserSearchKey = event.target.value;
    this.onSearchKey(this.routedUserSearchKey);
  }

  clearRoutedUserSearch() {
    this.routedUserSearchKey = '';
    this.onSearchKey('');
  }

  isDesignationEnabled() {
    const clientCode = localStorage.getItem("clientCode");
    this.apiService.doGetRequestWithResponse(ApiConstants.isDesignationRequired + clientCode, success => {
      if (success.status === 200) {
        this.isDesignation = success.body.designationRequired;
      }
    }, error => {
      console.log(error);
    })
  }

  fetchRestrictPickupTimeUpdateBySiteId(siteId: number): void {
    if (!siteId) {
      this.showUpdatePickupTimeToggle = false;
      return;
    }

    this.apiService.doGetRequestWithResponse(
      ApiConstants.restrictPickupTimeUpdateBySiteId + siteId,
      (response) => {
        const isRestricted =
          response?.status === 200 && response?.body?.restrictPickupTimeUpdate;
        this.showUpdatePickupTimeToggle = isRestricted;
        this.updatePickupTime = !isRestricted;
      },
      (error) => {
        this.showUpdatePickupTimeToggle = false;
        this.updatePickupTime = true;
        console.error('API Error fetching restrict pickup time update flag:', error);
      }
    );
  }

  showOrHideAddress(e) {
    if (e) {
      this.areaLandmark = true;
      this.onlyAddress = false;
    } else {
      this.onlyAddress = true;
      this.areaLandmark = false;
    }
  }

  getRoutedUserAddress(user: any): string {
    if (user?.landmark?.type === "H" && user?.landmark?.landmark) {
      return user.landmark.landmark;
    }
    if (user?.userLandmark != null) {
      if (user.userLandmark.type === "H") {
        return user.userLandmark.landmark || "NA";
      }
      if (user.userLandmark.area?.area) {
        return user.userLandmark.area.area + ", " + user.userLandmark.landmark;
      }
      return user.userLandmark.landmark || "NA";
    }
    const homePointLandmark = user?.tripUser?.userInfoDetails?.homePoint?.landmark;
    if (homePointLandmark) {
      return homePointLandmark;
    }
    return user?.tripUser?.userInfoDetails?.address || "NA";
  }

  private startAutoSaveInterval(): void {
    this.stopAutoSaveInterval();
    if (!this.autosaveFlag) {
      return;
    }
    this.autoSaveIntervalId = setInterval(() => this.autoSaveDraftSilently(), 20000);
  }

  private stopAutoSaveInterval(): void {
    if (this.autoSaveIntervalId) {
      clearInterval(this.autoSaveIntervalId);
      this.autoSaveIntervalId = null;
    }
  }

  private autoSaveDraftSilently(): void {
    if (!this.autosaveFlag || !this.tripsList?.length || this.isDraftSaving) {
      return;
    }
    const reqData = this.buildModifyTripRequestData(this.tripsList, false, true);
    if (!reqData.modifiedList.length) {
      return;
    }
    this.isDraftSaving = true;
    this.apiService.doPostRequestWithResponse(
      ApiConstants.autoSaveModifyTrips,
      reqData,
      success => {
        this.isDraftSaving = false;
      },
      error => {
        this.isDraftSaving = false;
        console.log('Background auto save error:', error);
      }
    );
  }
}
